webpackJsonp([1],Array(148).concat([
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(242),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PayForm__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PayForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PayForm__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Hello',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
    }, {
        path: '/zaplac/:token?',
        name: 'pay-form',
        component: __WEBPACK_IMPORTED_MODULE_3__components_PayForm___default.a,
        props: true
    }]
}));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(269);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: function state() {
        return {
            token: "",
            deliveryAddress: {
                Street: "Jana brzechwy",
                StreetNo: "5",
                City: "Rumia",
                PostalCode: "84-23",
                Lat: "",
                Lng: ""
            },
            testMode: false,
            directionServiceResults: false,
            divisionName: "",
            divisionSymbolExternal: "",
            deliveryCost: {
                inZoneDelivery: 0,
                paidDistanceDelivery: 0
            },
            deliveryDistances: {
                total: 0,
                paid: 0
            },
            pokId: 0,
            orderType: "", // [orderToPay, doubleOrder]
            orderCreated: false,
            linkToPay: "",

            urls: {
                getOrderDataForPayu: "/order/getPaymentsDetails",
                startPayment: "/startPayment",
                warehousesList: "/vendor/warehousesList/",
                getWhLocation: "/vendor/warehouse/",
                getZones: "/warehouse/getZones/",
                getPaymentsMethods: "/getPaymentsMethods/",
                getDeliveryData: "/delivery/getDeliveryData",
                getDeliveryZone: "/delivery/getZone/",
                outOfZone: "/delivery/test/outOfZone/",
                getDeliveryPrice: "/delivery/test/getDelivPrice/",
                getDates: "/delivery/getDates/",
                createFullOrder: "/api/order/createFullOrder",
                createDoubleOrder: "/order/createDoubleOrder/",
                createOrderToPay: "/order/createOrderToPay/"
            },
            urlsAAA: {
                warehousesList: "/callcenterApi/vendor/warehousesList/",
                getWhLocation: "/callcenterApi/vendor/warehouse/",
                getZones: "/callcenterApi/warehouse/getZones/",
                getPaymentsMethods: "/callcenterApi/getPaymentsMethods/",
                getDeliveryData: "/callcenterApi/delivery/getDeliveryData",
                getDeliveryZone: "/callcenterApi/delivery/getZone/",
                outOfZone: "/callcenterApi/delivery/test/outOfZone/",
                getDeliveryPrice: "/callcenterApi/delivery/test/getDelivPrice/",
                getDates: "/callcenterApi/delivery/getDates/",
                createFullOrder: "/callcenterApi/api/order/createFullOrder",
                createDoubleOrder: "/callcenterApi/order/createDoubleOrder/",
                createOrderToPay: "/callcenterApi/order/createOrderToPay/"
            }
        };
    },

    mutations: {
        setPokId: function setPokId(state, value) {
            state.pokId = value;
        },
        setDivisionName: function setDivisionName(state, value) {
            state.divisionName = value;
        },
        setDivisionExternalSymbol: function setDivisionExternalSymbol(state, value) {
            state.divisionSymbolExternal = value;
        },
        setDeliveryCostInZone: function setDeliveryCostInZone(state, value) {
            state.deliveryCost.inZoneDelivery = value;
        },
        setDeliveryCostPaidDistance: function setDeliveryCostPaidDistance(state, value) {
            state.deliveryCost.paidDistanceDelivery = value;
        },
        setDeliveryLocation: function setDeliveryLocation(state, value) {
            state.deliveryAddress.Lat = value.Lat;
            state.deliveryAddress.Lng = value.Lng;
        },
        setDeliveryDistTotal: function setDeliveryDistTotal(state, value) {
            state.deliveryDistances.total = value;
        },
        setDeliveryDistPaid: function setDeliveryDistPaid(state, value) {
            state.deliveryDistances.paid = value;
        },
        setOrderType: function setOrderType(state, value) {
            state.orderType = value;
        },
        setLinkToPay: function setLinkToPay(state, value) {
            state.linkToPay = value;
        },
        setOrderCreated: function setOrderCreated(state, value) {
            state.orderCreated = value;
        },
        setDirectionServiceResults: function setDirectionServiceResults(state, value) {
            state.directionServiceResults = value;
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(265),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'addressMap',
    props: ['step', 'address', 'warehouse'],
    data: function data() {
        return {
            map: null,
            directionsService: null,
            directionsRenderer: null,
            googleDistance: 0,
            divisionLocation: {},
            division: {},
            custLocation: {},
            urls: {
                'outOfZone': '/api/delivery/test/outOfZone/'
            },
            custLocationMarker: null,
            deliveryRoute: null
        };
    },


    mounted: function mounted() {
        var self = this;

        Event.$on('directionServiceResults', function (points) {
            console.log('MAMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM');
            console.log(points.routes["0"]);
            var pl = self.pathFromLeg(points.routes["0"].overview_polyline);
            console.log(pl);
            if (points) {
                self.$store.commit('setDirectionServiceResults', true);
            }
            var decodedPoints = google.maps.geometry.encoding.decodePath(points.routes["0"].overview_polyline);

            var encodedPolyline = new google.maps.Polyline({
                strokeColor: "#970E04",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                path: decodedPoints,
                clickable: false
            });
            encodedPolyline.setMap(self.map);
        });

        Event.$on('setDivision', function (custLocation) {
            console.log('setDivision - in adress map');
            if (custLocation) {
                self.division = custLocation;
                self.divisionLocation.Lat = custLocation.Lat;
                self.divisionLocation.Lng = custLocation.Lng;
            }
        });

        self.directionsService = new google.maps.DirectionsService();
        self.directionsRenderer = new google.maps.DirectionsRenderer();
        self.directionsRenderer.setMap(self.map);

        Event.$on('mapSetCustomLocation', function (custLocation) {
            console.log('mapSetCustomLocation***************************mapSetCustomLocation');
            if (custLocation) {
                if (self.custLocationMarker != null) {
                    self.custLocationMarker.setMap(null);
                    console.log('remove - marker');
                }
                self.addMarker(custLocation.Lat, custLocation.Lng, "Klient");
                self.custLocation = custLocation;
                self.map.panTo(new google.maps.LatLng(custLocation.Lat, custLocation.Lng));
            }
            // jest custom loc i wh
            self.getDirections();
        });
    },

    watch: {
        step: function step(val, oldVal) {
            var self = this;
            if (this.map === null) {
                this.initMap();
            }
            if (self.division.Lat) {
                self.addMarker(self.division.Lat, self.division.Lng, "");
                self.map.panTo(new google.maps.LatLng(self.division.Lat, self.division.Lng));
            }
        }
    },

    methods: {
        pathFromLeg: function pathFromLeg(leg) {
            //if (!google) { return; }
            var segments = [];
            _.forEach(leg.steps, function (_ref) {
                var points = _ref.polyline.points;

                var path = google.maps.geometry.encoding.decodePath(points);
                _.forEach(path, function (segment) {
                    return segments.push(segment);
                });
            });
            return segments;
        },
        showRoute: function showRoute(directionResult) {
            alert('showRoute');
            if (this.deliveryRoute != null) {
                this.deliveryRoute.setMap(null);
            }
            var myRoute = directionResult.routes[0].legs[0];
            var self = this;
            var linePath = [];

            for (var i = 0; i < myRoute.steps.length; i++) {
                linePath.push(myRoute.steps[i].start_point);
            }
            linePath.push(new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng));

            var lineOptions = {
                path: linePath,
                strokeWeight: 2,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8
            };
            var polyline = new google.maps.Polyline(lineOptions);
            polyline.setMap(this.map);
            this.deliveryRoute = polyline;
        },

        addMarker: function addMarker(lat, lng, label) {
            var coordinate = new google.maps.LatLng(lat, lng);
            var marker = new google.maps.Marker({
                position: coordinate,
                mapTypeControl: false,
                map: this.map,
                title: '' + label
            });
            // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
            marker.setMap(this.map);
            if (label === 'Klient') {
                console.log('ADDING CUSTOM MARKER');
                this.custLocationMarker = marker;
            }
        },

        drawLine: function drawLine(lineCoordinates, strokeCol) {
            console.log('DRAW LINIE IN ADDRES MAP');
            console.log(lineCoordinates);

            var pointCount = lineCoordinates.length;
            var linePath = [];
            for (var i = 0; i < pointCount; i++) {
                if (i == 0) {
                    this.map.panTo(new google.maps.LatLng(lineCoordinates[i][1], lineCoordinates[i][0]));
                }
                var tempLatLng = new google.maps.LatLng(lineCoordinates[i][1], lineCoordinates[i][0]);
                this.addMarker(lineCoordinates[i][1], lineCoordinates[i][0]);
                linePath.push(tempLatLng);
                console.log(lineCoordinates[i][1], lineCoordinates[i][0]);
            }
            var lineOptions = {
                path: linePath,
                strokeWeight: 2,
                strokeColor: strokeCol,
                strokeOpacity: 1
            };
            var polyline = new google.maps.Polyline(lineOptions);
            polyline.setMap(this.map);
        },

        initMap: function initMap() {
            console.log('INIT MAP');
            google.maps.visualRefresh = true;
            var centerPoint = [52.229676, 21.012229];
            var zoomLevel = 10;
            this.map = new google.maps.Map(document.getElementById('address-map'), {
                center: { lat: centerPoint[0], lng: centerPoint[1] },
                //disableDefaultUI: false,
                //scaleControl: true,
                scrollwheel: false,
                zoom: zoomLevel
            });
        },

        getWhString: function getWhString() {
            return this.warehouse.PostalCode + ' ' + this.warehouse.City + ' ' + this.warehouse.Street + ' ' + this.warehouse.StreetNo;
        },

        getCustAddressString: function getCustAddressString() {
            return this.address.PostalCode + ' ' + this.address.City + ' ' + this.address.Street + ' ' + this.address.StreetNo;
        },

        getDirections: function getDirections() {
            console.log('getDirections******');
            var self = this;
            //define an array that will hold all the waypoints
            var waypnts = [];
            //define a directionsRequest object
            var directionRequest;

            var orig = new google.maps.LatLng(self.divisionLocation.Lat, self.divisionLocation.Lng);
            var dest = new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng);

            orig = this.getWhString();
            dest = this.getCustAddressString();

            directionRequest = {
                origin: orig,
                destination: dest,
                travelMode: google.maps.TravelMode.DRIVING,
                avoidHighways: true,
                avoidTolls: true

            };

            // send the request to the directionsService
            self.directionsService.route(directionRequest, function (result, status) {
                console.log('directionsService - - - - - - - - ');
                console.log(status);
                if (status == google.maps.DirectionsStatus.OK) {
                    self.directionsRenderer.setDirections(result);
                    //self.showRoute(result);
                    console.log('SHOULD DRAW ROUTEE');
                    self.googleDistance = result.routes[0].legs[0].distance.text;
                    self.$emit('setDelivDistance', self.googleDistance);
                    return;
                    self.$http.post(self.urls.outOfZone, { divisionId: self.warehouse.ID, routePath: result.routes[0].overview_polyline }).then(function (response) {
                        if (response.data.lineCoords) {
                            //self.drawLine(response.data.lineCoords, '#000000');
                            var pointsCount = response.data.lineCoords.length;
                            self.addMarker(response.data.lineCoords[pointsCount - 1][1], response.data.lineCoords[pointsCount - 1][0], "Pkt końcowy strefy");
                            self.kmOutZone = response.data.kmOutZone;
                            console.log('USTAWIAM kmOutZone in AddressMap' + self.kmOutZone);
                            Event.$emit('kmOutZone', self.kmOutZone);
                        } else {
                            Event.$emit('kmDistance', self.googleDistance);
                        }
                    });
                } else {
                    alert('Cannot find directions because: ' + status);
                }
            });
        }
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'callCenterMap',
    props: ['step', 'delivery', 'warehouse', 'deliveryAddress'],
    data: function data() {
        return {
            circleTxt: '',
            map: null,
            directionsService: null,
            directionsRenderer: null,
            googleDistance: 0,
            divisionLocation: {},
            markers: [],
            zones: [],
            kmOutZone: '-',
            custLocation: {},
            mapZones: [],
            urls: {
                getWhLocation: '/api/vendor/warehouse/',
                getZones: '/api/warehouse/getZones/',
                outOfZone: '/api/delivery/test/outOfZone/'
            }
        };
    },


    mounted: function mounted() {
        var self = this;
        this.initMap();
        this.addMarker(52.229676, 21.012229, 'Warszawa');

        self.directionsService = new google.maps.DirectionsService();
        self.directionsRenderer = new google.maps.DirectionsRenderer();
        self.directionsRenderer.setMap(self.map);

        Event.$on('mapSetCustomLocation', function (custLocation) {
            if (custLocation) {
                self.addMarker(custLocation.Lat, custLocation.Lng, "Klient");
                self.custLocation = custLocation;
            }
            // jest custom loc i wh
            self.getDirections();
        });

        Event.$on('toMap', function (w) {
            self.showDivision(w);
        });
    },

    methods: {
        makeRouteTest: function makeRouteTest() {
            // var points = [[23.080920000002,53.1488599999921],[23.0840400000021,53.1448999999921],[23.0841900000021,53.1443199999921],[23.0838900000021,53.1441999999921],[23.080580000002,53.1447599999922],[23.076350000002,53.1455099999923],[23.071850000002,53.1463199999924],[23.065190000002,53.1474499999925],[23.062740000002,53.1478999999926],[23.060050000002,53.1483499999926],[23.0555500000019,53.1491799999927],[23.0360400000019,53.1526499999931],[23.0213600000018,53.1552499999934],[23.0140700000018,53.1565699999936],[23.0101300000017,53.1571499999936],[22.9976500000017,53.1594499999939],[22.9958400000017,53.1597799999939],[22.9907700000017,53.160669999994],[22.9889200000017,53.160879999994],[22.9859000000016,53.1610399999941],[22.9820700000016,53.1611699999941],[22.9796700000016,53.1612999999942],[22.9765600000016,53.1616999999942],[22.9753400000016,53.1619299999943],[22.9724000000016,53.1626299999943],[22.9683600000016,53.1635299999944],[22.9660200000016,53.1638799999944],[22.9636100000016,53.1640799999945],[22.9532300000015,53.1643099999946],[22.9483000000015,53.1642999999947],[22.9418800000015,53.1643099999948],[22.9372500000015,53.1643899999949],[22.9289600000014,53.164539999995],[22.9266200000014,53.1645599999951],[22.9252500000014,53.1644999999951],[22.9223200000014,53.1641499999951],[22.9207000000014,53.1638899999951],[22.8992400000013,53.1604899999955],[22.8852200000013,53.1582299999957],[22.8795100000013,53.1573199999957],[22.8754500000013,53.1567799999958],[22.8697800000012,53.1559199999959],[22.8626400000012,53.154759999996],[22.8594300000012,53.154239999996],[22.8565200000012,53.1536799999961],[22.8513700000012,53.1528299999961],[22.8317700000011,53.1496599999963],[22.8207700000011,53.1478699999965],[22.798580000001,53.1442899999967],[22.778660000001,53.1410399999969],[22.770560000001,53.139759999997],[22.7559500000009,53.1373799999971],[22.7347200000009,53.1339599999974],[22.7169300000008,53.1310599999975],[22.7091000000008,53.1298199999976],[22.7022100000008,53.1286199999976],[22.6925600000008,53.1270299999977],[22.6895700000008,53.1264299999977],[22.6856000000008,53.1258399999978],[22.6797400000008,53.1251899999978],[22.6769600000007,53.1248999999978],[22.6706600000007,53.1239999999979],[22.6517400000007,53.120959999998],[22.6454400000007,53.1196999999981],[22.6422100000007,53.1190999999981],[22.6321800000007,53.1175199999982],[22.6281900000007,53.1170599999982],[22.6263900000006,53.1169299999982],[22.6235100000006,53.1167699999982],[22.6159000000006,53.1166099999983],[22.6112600000006,53.1164799999983],[22.6092400000006,53.1162999999983],[22.6075300000006,53.1160899999983],[22.6053857295919,53.1157231147267]]
            // this.drawLine(points, 'FF0000')
        },
        getCustAddressString: function getCustAddressString() {
            return this.deliveryAddress.PostalCode + ' ' + this.deliveryAddress.City + ' ' + this.deliveryAddress.Street + ' ' + this.deliveryAddress.StreetNo;
        },

        getWhString: function getWhString() {
            return this.warehouse.PostalCode + ' ' + this.warehouse.City + ' ' + this.warehouse.Street + ' ' + this.warehouse.StreetNo;
        },

        getDirections: function getDirections() {
            var self = this;
            //define an array that will hold all the waypoints
            var waypnts = [];
            //define a directionsRequest object
            var directionRequest;

            var orig = new google.maps.LatLng(self.divisionLocation.lat, self.custLocation.lng);
            var dest = new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng);
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(orig));
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dest));

            orig = this.getWhString();
            dest = this.getCustAddressString();

            directionRequest = {
                origin: orig,
                destination: dest,
                // provideRouteAlternatives: false,
                travelMode: google.maps.TravelMode.DRIVING,
                avoidHighways: true,
                avoidTolls: true
                // drivingOptions: {
                //     trafficModel: 'optimistic',
                //     departureTime: new Date(Date.now() + 1000)
                // }
            };

            //send the request to the directionsService
            self.directionsService.route(directionRequest, function (result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    self.directionsRenderer.setDirections(result);
                    self.googleDistance = result.routes[0].legs[0].distance.text;
                    console.log('EMIT - directionServiceResults');
                    Event.$emit('directionServiceResults', result);

                    self.$http.post(self.urls.outOfZone, { divisionId: self.warehouse.ID, routePath: result.routes[0].overview_polyline }).then(function (response) {
                        if (response.data.lineCoords) {
                            self.drawLine(response.data.lineCoords);

                            var pointsCount = response.data.lineCoords.length;
                            self.addMarker(response.data.lineCoords[pointsCount - 1][1], response.data.lineCoords[pointsCount - 1][0], "Pkt końcowy strefy");
                            self.kmOutZone = response.data.kmOutZone;
                            console.log('USTAWIAM kmOutZone IN CallCenter' + self.kmOutZone);
                            Event.$emit('kmOutZone', self.kmOutZone);
                        } else {
                            Event.$emit('kmDistance', self.googleDistance);
                        }
                    });
                } else {
                    alert('Cannot find directions because: ' + status);
                }
            });
        },

        showDivision: function showDivision(w) {
            var self = this;
            self.$http.get(self.urls.getWhLocation + w.ID).then(function (response) {
                if (!response) {
                    return;
                }
                self.divisionLocation = response.data.coords;
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(response.data.coords.lat, response.data.coords.lng),
                    map: self.map
                });

                for (var i = 0; i < self.markers.length; i++) {
                    self.markers[i].setMap(null);
                }
                self.markers.push(marker);

                self.addMarker(marker);
                self.map.panTo(new google.maps.LatLng(response.data.coords.lat, response.data.coords.lng));
                self.getZones(w);

                Event.$emit('setDivision', { Lat: response.data.coords.lat, Lng: response.data.coords.lng });

                var centerInSales = [50.2692, 19.05583]; // katowice
                centerInSales = [51.76468, 18.06034]; // kalisz
                centerInSales = [51.803787, 19.423388]; // lodz
                centerInSales = [50.68096, 17.87439]; // opole
                centerInSales = [52.53581, 19.75717]; // płock
                centerInSales = [52.37172, 16.888746]; // poznan
                centerInSales = [50.019, 22.006027]; // rzeszow
                centerInSales = [50.585186, 22.057985]; // stalowa wola
                centerInSales = [53.42478, 14.59297]; // szczecin
                centerInSales = [50.764965, 16.258621]; // walbrzych
                centerInSales = [51.054855, 16.976307]; // wroclaw
                var radiousInSales = 21;
                //self.drawCityCircle([response.data.coords.lat, response.data.coords.lng], 21);
                //self.drawCityCircle([centerInSales[0], centerInSales[1]], radiousInSales);

            });
        },

        getZones: function getZones(w) {
            var self = this;
            this.zones = [];
            self.$http.get(self.urls.getZones + w.ID).then(function (response) {
                if (response.data.zones.length > 0) {
                    self.zones = response.data.zones;
                    self.drawZones();
                }
            });
        },

        drawZones: function drawZones() {
            if (this.zones.length === 0) {
                return;
            }
            for (var i = 0; i < this.mapZones.length; i++) {
                this.mapZones[i].setMap(null);
            }
            for (var i = 0; i < this.zones.length; i++) {
                var z = JSON.parse(this.zones[i].gjson);
                console.log('-----------');
                console.log(z.coordinates[0][0]);
                console.log(z.coordinates[0]);
                this.drawPolygon(z.coordinates[0]);
            }
        },

        drawPolygon: function drawPolygon(lineCoordinates) {
            var pointCount = lineCoordinates.length;
            var linePath = [];
            var str = '';
            for (var i = 0; i < pointCount; i++) {
                var tempLatLng = new google.maps.LatLng(lineCoordinates[i][1], lineCoordinates[i][0]);
                linePath.push(tempLatLng);
                str += lineCoordinates[i][0] + ',' + lineCoordinates[i][1] + ' ';
            }
            console.log(str);
            console.log('----------------------');
            var lineOptions = {
                path: linePath,
                strokeWeight: 3,
                strokeColor: '#959595',
                strokeOpacity: 0.8,
                fillColor: '#FFFF00',
                fillOpacity: 0.06
            };
            var polygon = new google.maps.Polygon(lineOptions);
            this.mapZones.push(polygon);
            polygon.setMap(this.map);
        },

        drawCircle: function drawCircle(point, radius, dir) {
            var d2r = Math.PI / 180; // degrees to radians
            var r2d = 180 / Math.PI; // radians to degrees
            var earthsradius = 6371; // 3963 is the radius of the earth in miles
            // 6371 - km

            var txt = 'POLYGON((';

            var points = 32;

            // find the raidus in lat/lon
            var rlat = radius / earthsradius * r2d;
            var rlng = rlat / Math.cos(point.lat() * d2r);

            var extp = new Array();
            if (dir == 1) {
                var start = 0;
                var end = points + 1; // one extra here makes sure we connect the path
            } else {
                var start = points + 1;
                var end = 0;
            }
            for (var i = start; dir == 1 ? i < end : i > end; i = i + dir) {
                var theta = Math.PI * (i / (points / 2));
                var ey = point.lng() + rlng * Math.cos(theta); // center a + radius x * cos(theta)
                var ex = point.lat() + rlat * Math.sin(theta); // center b + radius y * sin(theta)
                extp.push(new google.maps.LatLng(ex, ey));
                txt += ey + ' ' + ex + ',';
            }
            txt += '))';
            this.circleTxt = txt;
            return extp;
        },
        drawCityCircle: function drawCityCircle(centerPoint, r) {
            console.log('DRAW CITY CIRCLE');
            console.log(centerPoint);
            var self = this;
            //var radius = 11;
            //var centerPoint = [52.229676,  21.012229];
            var circle = new google.maps.Polygon({
                map: self.map,
                paths: [this.drawCircle(new google.maps.LatLng(centerPoint[0], centerPoint[1]), r, 1)],
                strokeColor: "#000000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35
            });
        },

        initMap: function initMap() {
            google.maps.visualRefresh = true;
            var centerPoint = [52.229676, 21.012229];
            var zoomLevel = 10;
            this.map = new google.maps.Map(document.getElementById('myMap'), {
                center: { lat: centerPoint[0], lng: centerPoint[1] },
                scrollwheel: false,
                zoom: zoomLevel
            });
            // this.makeRouteTest()
        },

        addMarker: function addMarker(lat, lng, label) {
            var coordinate = new google.maps.LatLng(lat, lng);
            var marker = new google.maps.Marker({
                position: coordinate,
                map: this.map,
                title: '' + label
            });
            // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
            marker.setMap(this.map);
        },

        drawLine: function drawLine(lineCoordinates) {
            var pointCount = lineCoordinates.length;
            var linePath = [];
            for (var i = 0; i < pointCount; i++) {
                var tempLatLng = new google.maps.LatLng(lineCoordinates[i][1], lineCoordinates[i][0]);
                linePath.push(tempLatLng);
            }
            var lineOptions = {
                path: linePath,
                strokeWeight: 2,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8
            };
            var polyline = new google.maps.Polyline(lineOptions);
            polyline.setMap(this.map);
        }

    }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'deliveryAddressSection',
    props: ['address', 'warehouse', 'step', 'zone'],
    data: function data() {
        return {
            addressError: false,
            isGeocoding: false,
            showAddressError: false,
            showFieldsError: {
                PostalCode: false,
                Street: false,
                StreetNo: false,
                City: false
            },
            fieldsError: {
                PostalCode: false,
                Street: false,
                StreetNo: false,
                FloorNo: false,
                City: false,
                ApartmentNo: false
            },
            defValues: {
                PostalCode: "Kod pocztowy",
                Street: "Ulica",
                StreetNo: "Nr budynku",
                FloorNo: "Piętro",
                City: "Miejscowość",
                ApartmentNo: null
            },
            urls: {
                getDeliveryData: '/api/delivery/getDeliveryData/'
            }
        };
    },

    methods: {

        geocodeAddress: function geocodeAddress() {
            var self = this;
            console.log('geocodeAddress - keup');

            if (document.activeElement.name === 'Kod-pocztowy' && this.validateAddress() && this.isGeocoding === false) {
                console.log('START GEPOCONDING');
                self.isGeocoding = true;
            } else {
                return;
            }

            this.showAddressError = false;

            var params = {
                Origin: {
                    DivisionID: self.warehouse.ID
                },
                Target: {
                    Street: self.address.Street,
                    StreetNo: self.address.StreetNo,
                    City: self.address.City,
                    PostalCode: self.address.PostalCode
                }
            };
            self.$http.post(self.urls.getDeliveryData, { delivParams: params }).then(function (response) {
                // @TODO - dodac emit z informacja o km i koszcie?
                console.log(response);
                console.log('/////////////////////////////////////////////////////////////////');
                if (response.data.status == 'cant_geocode') {
                    alert('Nie można ustalić adresu');
                    self.$emit('setOrderStep', 2);
                }
                if (response.data.distance) {
                    self.$emit('setDelivDistance', parseFloat(response.data.distance));
                }
                if (response.data.customerLocation) {
                    self.$emit('setCustomerLocation', response.data.customerLocation);
                    self.$store.commit('setDeliveryLocation', { Lat: response.data.customerLocation.Lat, Lng: response.data.customerLocation.Lng });
                }
                if (response.data.zone) {
                    self.zone.ID = response.data.zone.ID;
                    self.zone.Symbol = response.data.zone.Symbol;
                }
                self.isGeocoding = false;
            });
        },

        validateAddress: function validateAddress() {
            var validAddress = true;

            this.showAddressError = false;
            this.showFieldsError.PostalCode = false;
            this.showFieldsError.Street = false;
            this.showFieldsError.StreetNo = false;
            this.showFieldsError.City = false;

            this.fieldsError.PostalCode = false;
            this.fieldsError.Street = false;
            this.fieldsError.StreetNo = false;
            this.fieldsError.FloorNo = false;
            this.fieldsError.City = false;
            this.fieldsError.ApartmentNo = false;

            if (_.isEmpty(_.trim(this.address.City)) || this.address.City == this.defValues.City) {
                this.fieldsError.City = true;
                validAddress = false;
            }
            if (_.isEmpty(_.trim(this.address.Street)) || this.address.Street == this.defValues.Street) {
                this.fieldsError.Street = true;
                validAddress = false;
            }
            if (_.isEmpty(_.trim(this.address.StreetNo)) || this.address.StreetNo == this.defValues.StreetNo) {
                this.fieldsError.StreetNo = true;
                validAddress = false;
            }
            if (_.isEmpty(_.trim(this.address.PostalCode)) || !this.isValidPostalCode(this.address.PostalCode) || this.address.PostalCode == this.defValues.PostalCode) {
                console.log(this.address.PostalCode);
                this.fieldsError.PostalCode = true;
                validAddress = false;
            }

            this.addressError = !validAddress;

            return validAddress;
        },
        isValidPostalCode: function isValidPostalCode(postalCode) {
            return (/^\d{2}(-\d{3})$/.test(postalCode)
            );
        }
    },
    created: function created() {
        console.log("DASection - mounted");
        var self = this;

        Event.$on('orderStep', function (step) {

            if (step == 3) {
                console.log("DA - validateAddress");
                self.validateAddress();
                if (self.addressError == false) {
                    console.log("Adres poprawny");
                } else {
                    self.showAddressError = true;
                    self.showFieldsError.PostalCode = self.fieldsError.PostalCode === true ? true : false;
                    self.showFieldsError.Street = self.fieldsError.Street ? true : false;
                    self.showFieldsError.StreetNo = self.fieldsError.StreetNo ? true : false;
                    self.showFieldsError.City = self.fieldsError.City ? true : false;
                }
                self.$emit("setAddressError", self.addressError);
            }
        });

        this.address.Street = this.defValues.Street;
        this.address.StreetNo = this.defValues.StreetNo;
        this.address.ApartmentNo = this.defValues.ApartmentNo;
        this.address.City = this.defValues.City;
        this.address.PostalCode = this.defValues.PostalCode;
        this.address.FloorNo = this.defValues.FloorNo;

        if (this.$store.state.testMode) {
            console.log('STORE--------------');
            this.address.PostalCode = this.$store.state.deliveryAddress.PostalCode;
            this.address.Street = this.$store.state.deliveryAddress.Street;
            this.address.StreetNo = this.$store.state.deliveryAddress.StreetNo;
            //this.address.FloorNo = "";
            this.address.City = this.$store.state.deliveryAddress.City;
            //this.address.ApartmentNo = ""
        }
    }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'deliveryPointSection',
    props: ['step', 'orderData'],
    data: function data() {
        return {};
    }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'deliveryTypeBox',
    props: ['delivery', 'step'],
    data: function data() {
        return {};
    },


    methods: {
        setDeliveryType: function setDeliveryType(v) {
            this.delivery.withCarry = v;
        }
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'finalStep',
    props: ['payuUrl'],
    data: function data() {
        return {};
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'finishedOrderPopup',
    props: ["step"],
    data: function data() {
        return {};
    },

    methods: {
        hideMe: function hideMe() {
            this.$emit('setFinishedOrderPopup', false);
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'firstStepMap',
    props: ['coord'],
    data: function data() {
        return {
            map: null
        };
    },


    mounted: function mounted() {
        console.log('moubnt - sdffd');
        var self = this;
        this.initMap();

        Event.$on('setDivision', function (custLocation) {
            console.log('mapSetCustomLocation');
            if (custLocation) {
                self.addMarker(custLocation.Lat, custLocation.Lng, "");
                self.map.panTo(new google.maps.LatLng(custLocation.Lat, custLocation.Lng));
            }
        });
    },

    methods: {
        addMarker: function addMarker(lat, lng, label) {
            var coordinate = new google.maps.LatLng(lat, lng);
            var marker = new google.maps.Marker({
                position: coordinate,
                map: this.map,
                title: '' + label
            });
            // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
            marker.setMap(this.map);
        },

        initMap: function initMap() {
            google.maps.visualRefresh = true;
            var centerPoint = [52.229676, 21.012229];
            var zoomLevel = 10;
            this.map = new google.maps.Map(document.getElementById('first-step-map'), {
                center: { lat: centerPoint[0], lng: centerPoint[1] },
                scrollwheel: false,
                disableDefaultUI: true,
                scaleControl: false,
                mapTypeControl: false,
                zoom: zoomLevel
            });
        }
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StepBar__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VendorAgataLocationList__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VendorAgataLocationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VendorAgataLocationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrdeNavSection__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrdeNavSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OrdeNavSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderPrice__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderPrice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderPrice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelpSection__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelpSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HelpSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DeliveryPointSection__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DeliveryPointSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DeliveryPointSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeliveryAddressSection__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeliveryAddressSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DeliveryAddressSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderDetails__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrderDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderSummary__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OrderSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CallCenterMap__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CallCenterMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CallCenterMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FinalStep__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FinalStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__FinalStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FirstStepMap__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FirstStepMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__FirstStepMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddressMap__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddressMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AddressMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RightBox__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RightBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__RightBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SummaryBox__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SummaryBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SummaryBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ParcelsBox__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ParcelsBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ParcelsBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ParcelsSummaryBox__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ParcelsSummaryBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ParcelsSummaryBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeliveryTypeBox__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeliveryTypeBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__DeliveryTypeBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HelpBox__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HelpBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__HelpBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PayuForm__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PayuForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__PayuForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FinishedOrderPopup__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FinishedOrderPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__FinishedOrderPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PageMenu__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PageMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PageMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PageFooter__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PageFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__PageFooter__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PageMenu: __WEBPACK_IMPORTED_MODULE_22__PageMenu___default.a,
        PageFooter: __WEBPACK_IMPORTED_MODULE_23__PageFooter___default.a,
        DeliveryAddressSection: __WEBPACK_IMPORTED_MODULE_7__DeliveryAddressSection___default.a,
        DeliveryPointSection: __WEBPACK_IMPORTED_MODULE_6__DeliveryPointSection___default.a,
        OrderHelpSection: __WEBPACK_IMPORTED_MODULE_5__HelpSection___default.a,
        OrderPriceSection: __WEBPACK_IMPORTED_MODULE_4__OrderPrice___default.a,
        OrderNavSection: __WEBPACK_IMPORTED_MODULE_3__OrdeNavSection___default.a,
        OrderDetails: __WEBPACK_IMPORTED_MODULE_8__OrderDetails___default.a,
        VendorAgataLocationList: __WEBPACK_IMPORTED_MODULE_2__VendorAgataLocationList___default.a,
        StepBar: __WEBPACK_IMPORTED_MODULE_1__StepBar___default.a,
        OrderSummary: __WEBPACK_IMPORTED_MODULE_9__OrderSummary___default.a,
        CallCenterMap: __WEBPACK_IMPORTED_MODULE_10__CallCenterMap___default.a,
        FinalStep: __WEBPACK_IMPORTED_MODULE_11__FinalStep___default.a,
        FirstStepMap: __WEBPACK_IMPORTED_MODULE_12__FirstStepMap___default.a,
        AddressMap: __WEBPACK_IMPORTED_MODULE_13__AddressMap___default.a,
        RightBox: __WEBPACK_IMPORTED_MODULE_14__RightBox___default.a,
        SummaryBox: __WEBPACK_IMPORTED_MODULE_15__SummaryBox___default.a,
        ParcelsBox: __WEBPACK_IMPORTED_MODULE_16__ParcelsBox___default.a,
        ParcelsSummaryBox: __WEBPACK_IMPORTED_MODULE_17__ParcelsSummaryBox___default.a,
        DeliveryTypeBox: __WEBPACK_IMPORTED_MODULE_18__DeliveryTypeBox___default.a,
        HelpBox: __WEBPACK_IMPORTED_MODULE_19__HelpBox___default.a,
        PayuForm: __WEBPACK_IMPORTED_MODULE_20__PayuForm___default.a,
        FinishedOrderPopup: __WEBPACK_IMPORTED_MODULE_21__FinishedOrderPopup___default.a
    },
    name: "hello",
    data: function data() {
        return {
            isLoading: false,
            //payMethodsList: [], //TEST
            showFinishedOrderPopup: false,
            deliveryWithoutCarry: 15, // bez wniesienia
            testObj: null, // TODO - usunac po testach
            orderStep: 1,
            warehouseError: false,
            addressError: false,
            customerDataError: false,
            payuUrl: "",
            orderData: {
                orderNumber: "",
                order: {
                    extOrderId: "",
                    totalAmount: "",
                    language: "pl",
                    notifyUrl: "",
                    customerIp: "",
                    currencyCode: "",
                    continueUrl: "",
                    description: "",
                    payMethod: "",
                    buyer: {
                        email: "",
                        phone: "",
                        firstName: "",
                        lastName: ""
                    }
                },
                remarks: "",
                acceptPayuRules: true,
                warehouse: null,
                customer: {
                    FirstName: "Imię",
                    LastName: "Nazwisko",
                    Email: "E-mail",
                    MobilePhone: "Nr telefonu komórkowego"
                },
                address: {
                    Street: "",
                    StreetNo: "",
                    ApartmentNo: "",
                    PostalCode: "",
                    FloorNo: "",
                    City: "",
                    Lat: "",
                    Lng: ""
                },
                mapData: {},
                delivery: {
                    cost: "",
                    distance: "",
                    distanceOutOfZone: "",
                    timePeriod: "08:00 - 20:00", // domyślnie
                    serviceName: "Transport",
                    zoneName: "",
                    date: "",
                    withCarry: 1,
                    zone: {
                        Symbol: "",
                        ID: ""
                    },
                    costParts: {
                        inZoneDelivery: 0,
                        paidDistanceDelivery: 0
                    }
                },
                invoice: {
                    CompanyName: "",
                    Street: "",
                    StreetNo: "",
                    ApartmentNo: "",
                    PostalCode: "",
                    NIP: "",
                    City: ""
                },
                parts: [],
                division: "",
                Calculation: {
                    InZoneDelivery: 0,
                    PaidDistanceDelivery: 0
                }
            },
            urls: {
                createOrder: "/api/order/create",
                sendOrder: "/api/sendOrder",
                getDeliveryPrice: "/api/delivery/test/getDelivPrice/"
            }
        };
    },

    mounted: function mounted() {
        var self = this;
        Event.$on("kmOutZone", function (val) {
            //console.log('kmOutZone' + val);
            self.orderData.delivery.distanceOutOfZone = val;
        });

        Event.$on("changePartValue", function (sum) {
            //console.log('changePartValue' + sum);
            self.getDeliveryCost(sum);
        });

        Event.$on("changePartWeight", function (sum) {
            //console.log('changePartWeight' + sum);
            self.getDeliveryCost(sum);
        });

        Event.$on("directionServiceResults", function (points) {
            //console.log('MAMMMMMMMMMMMMMM')
        });
    },
    methods: {
        getFakePayments: function getFakePayments() {
            var self = this;
            self.$http.get("/api/fakePaymentsList/").then(function (response) {
                if (response.data.paymentsList) {
                    self.payMethodsList = response.data.paymentsList;
                } else {
                    //@TODO - jesli nie da sie obliczyc ceny
                }
            });
        },

        setFinishedOrderPopup: function setFinishedOrderPopup(v) {
            this.showFinishedOrderPopup = v;
        },

        preparePayu: function preparePayu(oData) {
            // TODO - dodac pozostale dane
            this.orderData.orderNumber = oData.OrderNumber;
            this.orderData.order.extOrderId = oData.extOrderId;
            this.orderData.order.totalAmount = this.orderData.delivery.cost * 100;
            this.orderData.order.language = 0;
            this.orderData.order.currencyCode = oData.currencyCode;
            this.orderData.order.notifyUrl = oData.notifyUrl;
            this.orderData.order.continueUrl = oData.continueUrl;
            this.orderData.order.customerIp = oData.customerIp;
            this.orderData.order.OrderNumber = oData.OrderNumber;
            this.orderData.order.OrderID = oData.OrderID;

            this.orderData.order.buyer.email = this.orderData.customer.Email;
            this.orderData.order.buyer.firstName = this.orderData.customer.FirstName;
            this.orderData.order.buyer.lastName = this.orderData.customer.LastName;
            this.orderData.order.buyer.phone = this.orderData.customer.MobilePhone;
            this.orderData.order.description = "Dostawa z wniesieniem " + oData.OrderNumber;
            this.orderData.order.pokId = this.$store.state.pokId;
        },

        pay: function pay() {
            var self = this;
            var valid = true;
            var oData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.orderData.order));
            delete oData.buyer;

            return self.$http.post(self.urls.sendOrder, {
                order: oData,
                buyer: self.orderData.order.buyer
            }).then(function (response) {
                if (!_.isEmpty(response.data)) {
                    if (!_.isEmpty(response.data.redirectUrl)) {
                        console.log(response.data.redirectUrl);
                        window.location.href = response.data.redirectUrl;
                    }
                }
            });
        },

        createOrder: function createOrder() {
            var self = this;
            self.orderData.division = this.$store.state.divisionName;
            self.orderData.divisionSymbolExternal = this.$store.state.divisionSymbolExternal;
            self.orderData.address.Lat = self.$store.state.deliveryAddress.Lat;
            self.orderData.address.Lng = self.$store.state.deliveryAddress.Lng;

            // koszty
            self.orderData.Calculation.InZoneDelivery = self.$store.state.deliveryCost.inZoneDelivery;
            self.orderData.Calculation.PaidDistanceDelivery = self.$store.state.deliveryCost.paidDistanceDelivery;
            // odleglosci

            if (self.$store.setOrderCreated === true || self.isLoading === true) {
                return;
            }
            self.isLoading = true;
            // SALES - dopisac
            console.log(self.orderData);

            var url = "";
            if (self.$store.state.orderType === "doubleOrder") {
                url = self.$store.state.urls.createDoubleOrder;
            } else if (self.$store.state.orderType === "orderToPay") {
                url = self.$store.state.urls.createOrderToPay;
            }

            self.$http.post(self.urls.createOrder, { orderData: self.orderData }).then(function (response) {
                if (response.data.status === "ok") {
                    self.$store.commit("setOrderCreated", true);
                    self.payuUrl = response.data.payuUrl;
                    // TODO SEARCH_NOW
                    self.preparePayu(response.data);
                    self.orderStep = 6;
                    Event.$emit("orderStep", 6);
                } else {
                    alert("Przepraszamy, nie można utworzyć zlecenia");
                }
                self.isLoading = false;
            });
        },

        parcelsValid: function parcelsValid(v) {
            if (v === true) {
                this.setOrderStep(4, v);
                console.log("parcels ok =- strartt ");
            } else {
                console.log("parcels BAD =- strartt ");
            }
        },

        changeMannualyDelivCost: function changeMannualyDelivCost(cost) {
            this.orderData.delivery.cost = cost;
        },

        setDeliveryCost: function setDeliveryCost(d) {
            var delivCost = parseFloat(d);
            if (this.orderData.delivery.withCarry === 0) {
                delivCost = delivCost - this.deliveryWithoutCarry;
            }
            this.orderData.delivery.cost = delivCost;
        },

        setCustomerLocation: function setCustomerLocation(custLocation) {
            Event.$emit("mapSetCustomLocation", custLocation);
        },

        setDelivDistance: function setDelivDistance(d) {
            console.log("setDelivDistance");
            if (d) {
                this.orderData.delivery.distance = d;
            }
        },

        setAddressError: function setAddressError(v) {
            this.addressError = v;
            if (v === false) {
                this.orderStep = 3;
                this.getDeliveryZone();
            }
        },

        setDelivTimePeriod: function setDelivTimePeriod(t) {
            this.orderData.delivery.timePeriod = t;
        },

        setDelivDate: function setDelivDate(d) {
            this.orderData.delivery.date = d;
        },

        removePart: function removePart(index) {
            //var p = _.find(this.orderData.parts, {ordNumber: part.ordNumber});
            //this.testObj = p;
            //let index = this.orderData.parts.indexOf(p)
            this.orderData.parts.splice(index, 1);
            //if (p) {
            //this.orderData.parts.splice(p);
            //}
        },

        addPart: function addPart(newOrderPart) {
            var ov = newOrderPart.ordValue === "Wpisz wartość zamówienia" || newOrderPart.ordValue === "" ? 0 : newOrderPart.ordValue;
            var newPart = {
                ordNumber: newOrderPart.ordNumber,
                ordValue: ov
            };
            console.log(newPart);
            this.orderData.parts.push(newPart);
        },

        setOrderStep: function setOrderStep(v, params) {
            this.warehouseError = false;
            console.log("orderStep" + v);
            if (v == 1) {
                this.orderStep = 1;
            } else if (v == 2) {
                if (this.orderData.warehouse == null) {
                    this.warehouseError = true;
                    return;
                } else {
                    this.orderStep = 2;
                }
            } else if (v == 3) {
                Event.$emit("orderStep", 3);
            } else if (v == 4) {
                if (params === true) {
                    Event.$emit("orderStep", 4);
                    this.orderStep = 4;
                } else {
                    Event.$emit("orderStep", 4);
                    Event.$emit("validateParts");
                }
            } else if (v == 5) {
                Event.$emit("orderStep", 5);
                if (!_.isEmpty(this.orderData.delivery.date)) {
                    this.orderStep = 5;
                }
            } else if (v == 6) {
                Event.$emit("checkCustomerData");
            }
        },

        getDeliveryZone: function getDeliveryZone() {
            var self = this;
            self.$http.get("/api/delivery/getZone/" + self.orderData.address.PostalCode).then(function (response) {
                if (response.data.status == "ok") {} else {
                    //@TODO - jesli nie da sie obliczyc ceny
                }
            });
        },

        getDeliveryCost: function getDeliveryCost(sum) {
            var self = this;

            if (this.orderData.warehouse === null) {
                return;
            }

            var partsValueSum = this.getPartsValueSum();
            var partsWeightSum = this.getPartsWeightSum();

            var params = {
                kmDistance: this.orderData.kmDistance,
                kmOutsideZone: this.orderData.delivery.distanceOutOfZone,
                divisionId: this.orderData.warehouse.ID,
                zone: this.orderData.delivery.zone,
                postalCode: this.orderData.address && this.orderData.address.PostalCode,
                orderValue: partsValueSum,
                orderWeight: partsWeightSum
            };

            self.$http.post(self.urls.getDeliveryPrice, { params: params }).then(function (response) {
                if (response.data.status === "ok") {
                    self.orderData.delivery.cost = response.data.cost;
                    self.$store.commit("setDeliveryCostInZone", response.data.costParts.inZoneDelivery);
                    self.$store.commit("setDeliveryCostPaidDistance", response.data.costParts.paidDistanceDelivery);
                    // store
                    //console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');
                    //alert(response.data.cost);
                    self.$emit("setDeliveryCost", response.data.cost);
                }
            });

            //@TODO - dodac parametry1111111
            //                self.$http.post("/api/delivery/getDeliveryData", {delivParams: params}).then(function (response) {
            //                    if (response.data.status == 'ok') {
            //                        console.log('settting cost form server.....');
            //                        self.orderData.delivery.cost = response.data.delivery.cost;
            //                        self.orderData.delivery.distance = response.data.delivery.distance;
            //                    } else {
            //                        //@TODO - jesli nie da sie obliczyc ceny
            //                    }
            //                });
        },

        getPartsValueSum: function getPartsValueSum() {
            if (_.isEmpty(this.orderData.parts)) {
                return "0.00";
            }
            var sum = 0;
            _.forEach(this.orderData.parts, function (item) {
                if (parseFloat(item.ordValue)) {}
                var properItemValue = parseFloat(item.ordValue);
                if (!properItemValue) {
                    properItemValue = 0;
                }
                sum += properItemValue;
            });
            if (_.isNaN(sum)) {
                return "0.00";
            }
            return sum.toFixed(2);
        },

        getPartsWeightSum: function getPartsWeightSum() {
            if (_.isEmpty(this.orderData.parts)) {
                return "0.00";
            }
            var sum = 0;
            _.forEach(this.orderData.parts, function (item) {
                if (parseFloat(item.ordWeight)) {}
                var properItemValue = parseFloat(item.ordWeight);
                if (!properItemValue) {
                    properItemValue = 0;
                }
                sum += properItemValue;
            });
            if (_.isNaN(sum)) {
                return "0.00";
            }
            return sum.toFixed(2);
        },

        setVendorWarehouse: function setVendorWarehouse(w) {
            this.orderData.warehouse = w;
            this.warehouseError = false;
            this.orderData.delivery.withCarry = 1;
            Event.$emit("toMap", w);
        },

        getCoordForDivision: function getCoordForDivision(wId) {
            console.log(wId);
        },

        setDeliveryOptionsError: function setDeliveryOptionsError(v) {
            if (!v) {
                //Event.$emit("orderStep", 4);
                this.getDeliveryCost();
                this.orderStep = 4;
            }
        },

        setCustomerDataError: function setCustomerDataError(v) {
            console.log("receicve setCustomerDataError");
            this.customerDataError = v;
            if (v == false && this.orderStep == 5) {
                this.createOrder();
            }
        }
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'helpBox',
    props: ["step"],
    data: function data() {
        return {};
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'orderHelpSection',
    props: ["step"],
    data: function data() {
        return {};
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'orderNavSection',
    props: ["step"],
    data: function data() {
        return {
            stepsCount: 5
        };
    },

    methods: {

        makeOrder: function makeOrder(orderType) {
            if (orderType === 'doubleOrder') {
                this.$store.commit('setOrderType', 'doubleOrder');
            } else if (orderType === 'orderToPay') {
                this.$store.commit('setOrderType', 'orderToPay');
            }
            this.$emit('setOrderStep', this.step + 1);
        },

        goHome: function goHome() {
            // @TODO
            window.location = '/';
        },

        decreseStep: function decreseStep() {
            if (this.step === 6) {
                this.$emit('setFinishedOrderPopup', true);
            } else {
                this.$emit('setOrderStep', this.step - 1);
            }
        },

        pay: function pay() {
            this.$emit('pay');
        },

        setStep: function setStep() {
            console.log("setStep" + this.step);
            if (this.step === 2 && !this.$store.state.directionServiceResults) {
                return;
            } else {
                this.$emit('setOrderStep', this.step + 1);
            }
        },

        createOrder: function createOrder() {
            console.log('createOrder');
            this.$emit('createOrder');
        }
    },

    computed: {
        orderType: function orderType() {
            return this.$store.state.orderType;
        },
        orderCreated: function orderCreated() {
            return this.$store.state.orderCreated;
        }
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'orderDetails',
    props: ['orderParts', 'address', 'warehouse'],
    data: function data() {
        return {
            selDate: '',
            threeAvailableDates: [],
            availableDates: [],
            orderPartsError: false,
            orderPartErrorNum: false,
            orderPartErrorValue: false,
            showAllDates: false,
            deliveryOptionsError: false,
            kmOutsideZone: 0,
            zone: {
                Symbol: '',
                ID: ''
            },
            deliveryOptionsErrors: {
                parts: false,
                date: false,
                period: false
            },

            orderPart: {
                ordNumber: "Wpisz numer zamówienia",
                ordValue: "Wpisz wartość zamówienia"
            },
            otherDates: {
                date: "Inny termin",
                note: 'Pokaż dostępne dni',
                defaultDate: "Inny termin",
                defaultNote: 'Pokaż dostępne dni'
            },
            timePeriods: ["10:00 - 14:00", "13:00 - 17:00", "16:00 - 20:00"],
            currentDate: '',
            currentTimePeriod: '10:00 - 14:00',
            urls: {
                getDates: "/api/delivery/getDates/",
                calculateDeliveryCost: '/api/delivery/calculateDeliveryCost',
                getDeliveryData: '/api/delivery/getDeliveryData/',
                getDeliveryPrice: '/api/delivery/test/getDelivPrice/'
            }
        };
    },


    watch: {
        selDate: function selDate(val) {
            if (_.isEmpty(val)) {
                this.showAllDates = false;
                this.otherDates.date = this.otherDates.defaultDate;
                this.otherDates.note = this.otherDates.defaultNote;
            } else {
                this.otherDates.date = val;
                var d = _.find(this.availableDates, { date: val });
                console.log(d);
                if (d) {
                    this.otherDates.note = d.dayName;
                    this.currentDate = {
                        moment: __WEBPACK_IMPORTED_MODULE_0_moment___default()(d.date),
                        date: d.date,
                        dayName: d.dayName
                    };
                }
            }
        }
    },

    mounted: function mounted() {
        var self = this;

        self.setTimePeriod(self.timePeriods[0]);

        Event.$on("kmDistance", function (km) {
            console.log('kmDistance' + km);
            km = km.replace('km', '');
            km = km.replace(',', '.');
            self.kmDistance = parseFloat(km);
        });

        Event.$on("kmOutZone", function (km) {
            console.log('kmOutZone' + km);
            self.kmOutsideZone = km;
        });

        Event.$on("orderStep", function (stepId) {
            if (stepId == 4) {
                self.$http.post(self.urls.getDates, { postalCode: self.address.PostalCode, divisionId: self.warehouse.ID }).then(function (response) {
                    self.availableDates = response.data.dates;
                    self.threeAvailableDates = response.data.dates.slice(0, 3);
                });
                // Geokodowanie
                var address = self.getStringAddress();
                console.log('|' + address + '|');
                if (_.isEmpty(_.trim(address))) {
                    return;
                }
                //self.$http.post("/api/delivery/geocodeAddress/", {address: address, divisionId: self.warehouse.ID}).then(function (response) {
                var params = {
                    Origin: {
                        DivisionID: self.warehouse.ID
                    },
                    Target: {
                        Street: self.address.Street,
                        StreetNo: self.address.StreetNo,
                        City: self.address.City,
                        PostalCode: self.address.PostalCode
                    }
                };
                self.$http.post(self.urls.getDeliveryData, { delivParams: params }).then(function (response) {
                    // @TODO - dodac emit z informacja o km i koszcie?
                    console.log(response);
                    if (response.data.status == 'cant_geocode') {
                        alert('Nie można ustalić adresu');
                        self.$emit('setOrderStep', 2);
                    }
                    if (response.data.distance) {
                        self.$emit('setDelivDistance', parseFloat(response.data.distance));
                    }
                    if (response.data.customerLocation) {
                        self.$emit('setCustomerLocation', response.data.customerLocation);
                    }
                    if (response.data.zone) {
                        self.zone = response.data.zone;
                    }
                });
            } else if (stepId == 5) {
                self.validateDelivery();
            }
        });
    },

    methods: {

        checkCost: function checkCost() {
            var self = this;
            var params = {
                Origin: {
                    DivisionID: self.warehouse.ID
                },
                Target: {
                    Street: self.address.Street,
                    StreetNo: self.address.StreetNo,
                    City: self.address.City,
                    PostalCode: self.address.PostalCode
                }
            };
            params.orderValue = self.partsSum;
            self.$http.post(self.urls.calculateDeliveryCost, { delivParams: params }).then(function (response) {
                if (response.data.calculation) {
                    self.$emit("setDeliveryCost", response.data.calculation.price);
                    console.log('response.data.calculation.price');
                    console.log(response.data.calculation.price);
                }
            });
        },

        validateDelivery: function validateDelivery() {
            this.deliveryOptionsError = false;
            this.deliveryOptionsErrors.date = false;
            this.deliveryOptionsErrors.period = false;

            if (this.currentDate == '') {
                this.deliveryOptionsErrors.date = true;
                this.deliveryOptionsError = true;
            }

            if (_.isEmpty(this.currentTimePeriod)) {
                this.deliveryOptionsErrors.period = true;
                this.deliveryOptionsError = true;
            }
            //currentDate
            this.$emit("setDeliveryOptionsError", this.deliveryOptionsError);
        },

        setTimePeriod: function setTimePeriod(t) {
            console.log(t);
            var tp = this.timePeriods[t];
            this.currentTimePeriod = tp;
            this.$emit("setDelivTimePeriod", tp);
        },

        clickAllDates: function clickAllDates() {
            this.showAllDates = !this.showAllDates;
            this.currentDate = '';
        },

        selectDate: function selectDate(d) {
            this.currentDate = d;
            console.log(d);
            this.showAllDates = false;
            this.otherDates.date = this.otherDates.defaultDate;
            this.otherDates.note = this.otherDates.defaultNote;
            this.deliveryOptionsErrors.date = false;
            this.$emit("setDelivDate", d);
        },

        removePart: function removePart(part) {
            this.$emit("removePart", part);
        },

        addPart: function addPart() {
            console.log("addPart");
            var isValid = this.isValidOrderPart();
            if (!isValid) {
                return;
            }

            this.orderPart.ordValue = parseFloat(this.orderPart.ordValue);
            this.$emit("addPart", this.orderPart);
            setTimeout(this.clearPart, 100);
        },

        isValidOrderPart: function isValidOrderPart() {
            console.log('isValidOrderPart');
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;

            if (_.isEmpty(_.trim(this.orderPart.ordNumber)) || this.orderPart.ordNumber == "Wpisz numer zamówienia") {
                this.orderPartErrorNum = true;
            }
            if (_.isEmpty(_.trim(this.orderPart.ordValue)) || this.orderPart.ordValue == "Wpisz wartość zamówienia") {
                this.orderPartErrorValue = true;
            }

            var oValue = parseFloat(this.orderPart.ordValue);

            if (_.isNaN(oValue)) {
                this.orderPartErrorValue = true;
            }
            if (this.orderPartErrorValue === true || this.orderPartErrorValue === true) {
                return false;
            }
            return true;
        },

        clearPart: function clearPart() {
            this.orderPart.ordNumber = "";
            this.orderPart.ordValue = "";
        },

        getStringAddress: function getStringAddress() {
            return this.address.City + ' ' + this.address.Street + ' ' + this.address.StreetNo;
        }
    },

    computed: {
        partsSum: function partsSum() {
            if (_.isEmpty(this.orderParts)) {
                return "0.00";
            }
            return _.sumBy(this.orderParts, 'ordValue').toFixed(2);
        }
    },

    filters: {
        toFixed: function toFixed(v) {
            return v.toFixed(2);
        }
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'orderPriceSection',
    props: ['delivery', 'step'],

    data: function data() {
        return {
            manualDeliveryCost: '',
            deliveryCostError: false,
            showCostInput: false
        };
    },


    methods: {
        changeCost: function changeCost() {
            var cost = parseFloat(this.manualDeliveryCost);
            if (isNaN(cost) === true) {
                alert('Wpisz liczbę');
                return;
            }
            this.$emit('changeMannualyDelivCost', cost);
        },
        showChangeCostInput: function showChangeCostInput() {
            this.showCostInput = true;
        }
    },

    computed: {
        deliveryCost: function deliveryCost() {
            if (this.delivery.cost == '' || !_.isNumber(parseFloat(this.delivery.cost))) {
                return "0.00";
            }
            var c = parseFloat(this.delivery.cost);
            return c.toFixed(2);
        }
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PayuForm__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PayuForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PayuForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "orderSummary",
    props: ["step", "orderData"],
    components: {
        PayuForm: __WEBPACK_IMPORTED_MODULE_0__PayuForm___default.a
    },
    data: function data() {
        return {
            methodsList: [],
            showInvoicePart: false,
            customerDataError: false,
            noEmail: false,
            customerFieldsError: {
                FirstName: false,
                LastName: false,
                Email: false,
                MobilePhone: false
            },
            urls: {
                getPayMethodsList: "/api/getPaymentsMethods/"
            }
        };
    },


    methods: {
        getPayMethodsList: function getPayMethodsList() {
            var self = this;
            self.$http.get(self.urls.getPayMethodsList + "?pokId=" + self.$store.state.pokId).then(function (resp) {
                self.methodsList = resp.data.methods;
            });
        },

        isValidMobilePhone: function isValidMobilePhone(mobilePhone) {
            return (/^\d{9}$/.test(mobilePhone)
            );
        },

        showInfBox: function showInfBox() {
            this.showInvoicePart = true;
            var cancelScroll = this.$scrollTo("body", 1000, { offset: 800 });
            //this.copyData();
        },

        copyData: function copyData() {
            this.invoice.FirstName = this.orderData.customer.FirstName;
            this.invoice.LastName = this.orderData.customer.LastName;
            this.invoice.Street = this.orderData.address.Street;
            this.invoice.StreetNo = this.orderData.address.StreetNo;
            this.invoice.ApartmentNo = this.orderData.address.ApartmentNo;
            this.invoice.PostalCode = this.orderData.address.PostalCode;
            this.invoice.City = this.orderData.address.City;
        },

        emailIsValid: function emailIsValid(email) {
            return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
            );
        },

        validateCustomer: function validateCustomer() {
            this.customerDataError = false;
            if (_.isEmpty(_.trim(this.orderData.customer.FirstName)) || _.trim(this.orderData.customer.FirstName) === "Imię") {
                this.customerFieldsError.FirstName = true;
                this.customerDataError = true;
            }
            if (_.isEmpty(_.trim(this.orderData.customer.LastName)) || _.trim(this.orderData.customer.LastName) === "Nazwisko") {
                this.customerFieldsError.LastName = true;
                this.customerDataError = true;
            }
            if (!this.noEmail && (_.isEmpty(_.trim(this.orderData.customer.Email)) || _.trim(this.orderData.customer.Email) === "E-mail" || !this.emailIsValid(this.orderData.customer.Email))) {
                this.customerFieldsError.Email = true;
                this.customerDataError = true;
            }
            if (_.isEmpty(_.trim(this.orderData.customer.MobilePhone))) {
                this.customerFieldsError.MobilePhone = true;
                this.customerDataError = true;
            }
            if (!this.isValidMobilePhone(this.orderData.customer.MobilePhone)) {
                this.customerFieldsError.MobilePhone = true;
                this.customerDataError = true;
            }
            console.log("FINISH validateCustomer");
            //this.$emit("setCustomerDataError", this.customerDataError);
        }
    },

    mounted: function mounted() {
        var self = this;

        Event.$on("checkCustomerData", function () {
            self.validateCustomer();
            self.$emit("setCustomerDataError", self.customerDataError);
            console.log("emit checkCustomerData");
        });

        Event.$on("orderStep2", function (stepId) {
            console.log("orderStep - order summmary ");
            if (stepId == 6) {
                console.log("FINISH ORDER");
                //self.validateCustomer();
            }
        });
    },

    watch: {
        step: function step(nv) {
            if (nv === 2) {
                this.getPayMethodsList();
            }
        }
    },

    computed: {
        orderType: function orderType() {
            return this.$store.state.orderType;
        },
        linkToPay: function linkToPay() {
            return this.$store.state.linkToPay;
        }
    },

    filters: {
        toFixed: function toFixed(val) {
            if (_.trim(val) == "") {
                return "";
            }
            var vNum = parseFloat(val);
            if (_.isNaN(vNum)) {
                return "-";
            }
            return vNum.toFixed(2);
            return "";
        }
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "pageFooter"
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "pageMenu"
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "parcelsBox",
    props: ["step", "orderParts"],
    data: function data() {
        return {
            deliveryParcelsError: false,
            orderPartsError: false,
            orderPartErrorNum: false,
            orderPartErrorValue: false,
            orderPartDef: {
                ordNumber: "Wpisz numer zamówienia",
                ordValue: "Wpisz wartość zamówienia",
                ordWeight: "Wpisz wagę przesyłki"
            },
            orderPart: {
                ordNumber: "Wpisz numer zamówienia",
                ordValue: "Wpisz wartość zamówienia",
                ordWeight: "Wpisz wagę przesyłki"
            }
        };
    },


    mounted: function mounted() {
        var self = this;
        if (this.orderParts.length == 0) {
            this.orderParts.push({
                ordNumber: "" + this.orderPartDef.ordNumber,
                ordValue: "" + this.orderPartDef.ordValue
            });
        }
        Event.$on("validateParts", function () {
            var parcelsValid = self.validateParcels();
            self.$emit("parcelsValid", parcelsValid);
        });

        Event.$on("orderStep", function (stepId) {
            if (stepId == 4) {
                //var validParcels = self.validateParcels();
            }
        });
    },

    methods: {
        validateParcels: function validateParcels() {
            var self = this;

            this.deliveryParcelsError = false;
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;

            if (this.orderParts.length === 1 && this.orderParts[0].ordNumber === "" + this.orderPartDef.ordNumber && this.orderParts[0].ordValue === "" + this.orderPartDef.ordValue) {
                this.deliveryParcelsError = true;
            } else if (this.orderParts.length === 1 && (_.trim(this.orderParts[0].ordNumber) === "" || this.orderParts[0].ordNumber === "" + this.orderPartDef.ordNumber) && this.orderParts[0].ordValue !== "" + this.orderPartDef.ordValue) {
                this.orderPartErrorNum = true;
            } else if (this.orderParts.length === 1 && this.orderParts[0].ordNumber !== "" + this.orderPartDef.ordNumber && (_.trim(this.orderParts[0].ordValue) === "" || this.orderParts[0].ordValue === "" + this.orderPartDef.ordValue)) {
                this.orderPartErrorValue = true;
            } else if (this.orderParts.length > 1) {
                _.forEach(this.orderParts, function (part) {
                    if (_.trim(part.ordNumber) === "" || _.trim(part.ordNumber) === self.orderPartDef.ordNumber) {
                        self.orderPartErrorNum = true;
                    }
                    if (_.trim(part.ordValue) === "" || _.trim(part.ordValue) === self.orderPartDef.ordValue) {
                        self.orderPartErrorValue = true;
                    }
                });
            }

            if (this.deliveryParcelsError === true || this.orderPartErrorNum === true || this.orderPartErrorValue === true) {
                return false;
            }
            return true;
        },

        validatePart: function validatePart(part) {
            this.deliveryParcelsError = false;
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;
            if (_.trim(part.ordNumber) === "" || _.isEmpty(_.trim(part.ordNumber)) || _.trim(part.ordNumber) === "Wpisz numer zamówienia") {
                this.orderPartErrorNum = true;
            }
            if (_.isEmpty(_.trim(part.ordValue)) || part.ordValue === "Wpisz wartość zamówienia") {
                this.orderPartErrorValue = true;
            }
            if (_.isEmpty(_.trim(part.ordWeight)) || part.ordWeight === "Wpisz wagę przesyłki") {
                this.orderPartErrorValue = true;
            }

            var oValue = parseFloat(part.ordValue);

            if (_.isNaN(oValue)) {
                this.orderPartErrorValue = true;
            }
            if (this.orderPartErrorNum === true || this.orderPartErrorValue === true) {
                return false;
            }
            return true;
        },

        isValidOrderPart: function isValidOrderPart() {
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;
            this.deliveryParcelsError = false;

            if (_.trim(this.orderPart.ordNumber) === "" || _.isEmpty(_.trim(this.orderPart.ordNumber)) || _.trim(this.orderPart.ordNumber) === "Wpisz numer zamówienia") {
                this.orderPartErrorNum = true;
            }
            if (_.isEmpty(_.trim(this.orderPart.ordValue)) || this.orderPart.ordValue === "Wpisz wartość zamówienia") {
                this.orderPartErrorValue = true;
            }

            if (_.isEmpty(_.trim(this.orderPart.ordWeight)) || this.orderPart.ordWeight === "Wpisz wagę przesyłki") {
                this.orderPartErrorValue = true;
            }

            var oValue = parseFloat(this.orderPart.ordValue);

            if (_.isNaN(oValue)) {
                this.orderPartErrorValue = true;
            }
            if (this.orderPartErrorNum === true || this.orderPartErrorValue === true) {
                this.deliveryParcelsError = true;
                return false;
            }
            return true;
        },

        clearPart: function clearPart() {
            this.orderPart.ordNumber = this.orderPartDef.ordNumber;
            this.orderPart.ordValue = this.orderPartDef.ordValue;
            this.orderPart.ordWeight = this.orderPartDef.ordWeight;
        },

        removePart: function removePart(part) {
            this.$emit("removePart", part);
        },

        addPart: function addPart() {
            var ordValue = 0;
            if (this.orderPartDef.ordValue === "Wpisz wartość zamówienia") {} else {
                ordValue = this.orderPartDef.ordValue;
            }
            var ordWeight = 0;
            if (this.orderPartDef.ordWeight === "Wpisz wagę przesyłki") {} else {
                ordWeight = this.orderPartDef.ordWeight;
            }
            var newParcel = {
                ordNumber: "" + this.orderPartDef.ordNumber,
                ordValue: "" + ordValue,
                ordWeight: "" + ordWeight
            };
            this.$emit("addPart", newParcel);
            //setTimeout(this.clearPart, 100);
        }
    },

    filters: {
        toFixed: function toFixed(v) {
            return v.toFixed(2);
        }
    },

    computed: {
        partsValueSum: function partsValueSum() {
            var sum = 0;

            if (_.isEmpty(this.orderParts) || this.orderParts[0].ordValue === "") {
                sum = 0;
            }
            var self = this;
            _.forEach(this.orderParts, function (item) {
                var itemValue = parseFloat(item.ordValue);
                if (parseFloat(item.ordValue)) {
                    sum += parseFloat(item.ordValue);
                } else {
                    sum += 0;
                }
            });
            if (_.isNaN(sum)) {
                sum = 0;
            }
            Event.$emit("changePartValue", sum);
            return sum.toFixed(2);
        },
        partsWeightSum: function partsWeightSum() {
            var sum = 0;

            if (_.isEmpty(this.orderParts) || this.orderParts[0].ordWeight === "") {
                sum = 0;
            }
            var self = this;
            _.forEach(this.orderParts, function (item) {
                var itemValue = parseFloat(item.ordWeight);
                if (parseFloat(item.ordWeight)) {
                    sum += parseFloat(item.ordWeight);
                } else {
                    sum += 0;
                }
            });
            if (_.isNaN(sum)) {
                sum = 0;
            }
            Event.$emit("changePartWeight", sum);
            return sum.toFixed(2);
        }
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'parcelsSummaryBox',
    props: ["step", "orderParts"],
    data: function data() {
        return {};
    },


    mounted: function mounted() {},

    methods: {},

    filters: {
        toFixed: function toFixed(v) {
            console.log(v);

            if (v === 'Wpisz wartość zamówienia') {
                return '0.00';
            }

            if (_.isEmpty(v) || v === '') {
                return "0.00";
            }
            v = parseFloat(v);
            console.log(v);

            return v.toFixed(2);
        }
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageMenu__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageFooter__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageFooter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { PageMenu: __WEBPACK_IMPORTED_MODULE_0__PageMenu___default.a, PageFooter: __WEBPACK_IMPORTED_MODULE_1__PageFooter___default.a },
    name: "PayForm",
    props: ["token"],

    data: function data() {
        return {
            isLoading: false,
            error: false,
            errorReason: "",
            orderData: {
                delivery: {
                    cost: "",
                    currencyCode: ""
                },
                customer: {
                    FirstName: "",
                    LastName: ""
                }
            },

            order: null
        };
    },


    methods: {
        startPayment: function startPayment() {
            var url = this.$store.state.urls.startPayment;
            var self = this;
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            self.$http.post(url, { order: self.order }).then(function (response) {
                self.isLoading = false;

                if (response.data.status === "ok") {
                    window.location.href = response.data.redirectUrl;
                }
            });
        },

        assignValues: function assignValues(ordData) {
            console.log(ordData);
            this.orderData.delivery.cost = ordData.totalAmount;
            this.orderData.delivery.currencyCode = ordData.currencyCode;
            this.orderData.customer.FirstName = ordData.buyer.firstName;
            this.orderData.customer.LastName = ordData.buyer.lastName;
        },

        getOrderData: function getOrderData() {
            if (!this.token) {
                return;
            }

            var self = this;

            console.log("getOrderData");
            var url = this.$store.state.urls.getOrderDataForPayu;
            self.$http.get(url + "?token=" + self.token).then(function (response) {
                if (response.data.status === "error") {
                    self.error = true;
                    self.errorReason = response.data.reason;
                } else if (response.data.status === "ok") {
                    self.order = response.data.orderData;
                    self.order.token = self.token;
                    self.assignValues(response.data.orderData);
                }
            });
        }
    },

    filters: {
        toFixed: function toFixed(val) {
            if (_.trim(val) == "") {
                return "";
            }
            var vNum = parseFloat(val);
            if (_.isNaN(vNum)) {
                return "-";
            }
            return vNum.toFixed(2);
            return "";
        }
    },

    mounted: function mounted() {
        console.log("reday - form payy u");

        this.getOrderData();
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'payuForm',
    props: ['step', 'order'],
    data: function data() {
        return {
            urls: {
                sendOrder: 'zadbanoApiapi/sendOrder/'
            }
        };
    },


    mounted: function mounted() {},

    methods: {
        sendForm: function sendForm(e) {
            console.log('sendForm');
            var self = this;
            //e.stopPropagation();
            e.preventDefault();
            var valid = true;
            if (valid) {
                return self.request({
                    method: 'post',
                    endPoint: self.urls.sendOrder }, {
                    order: self.order,
                    buyer: self.order.buyer
                }).done(function (data) {
                    if (!_.isEmpty(data)) {
                        if (!_.isEmpty(data.redirectUrl)) {
                            console.log(data.redirectUrl);
                            window.location.href = data.redirectUrl;
                        }
                    }
                });
            }
        }
    }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rightBox',
    props: ["step"],
    data: function data() {
        return {
            headings: ['', 'Witaj w świecie dostaw DTS!', 'Wprowadzanie adresu realizacji', 'Dodawanie zamówień', 'Wybór terminu realizacji', 'Wprowadzanie danych odbiorcy']
        };
    },


    mounted: function mounted() {},

    methods: {}
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'stepBar',
    props: ['step'],
    data: function data() {
        return {};
    }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'summaryBox',
    props: ['step', 'orderData'],
    data: function data() {
        return {};
    },

    filters: {
        formatDistance: function formatDistance(v) {
            return v.replace('-', '');
        }
    }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vendorAgataLocationList',
    props: ['warehouseError'],
    data: function data() {
        return {
            vendorId: 2,
            locationId: null,
            location: null,
            locations: []
        };
    },

    methods: {
        setWarehouse: function setWarehouse(loc) {
            console.log('LOCATION:');
            console.log(loc);
            this.location = loc;
            this.locationId = loc.ID;
            this.$store.commit('setDivisionName', loc.SalesName);
            this.$store.commit('setDivisionExternalSymbol', loc.SymbolExternal);
            this.$store.commit('setPokId', loc.ID);
            this.$emit("setVendorWarehouse", loc);
        }
    },
    mounted: function mounted() {

        var self = this;
        this.$http.get("/api/vendor/warehousesList/" + this.vendorId).then(function (response) {
            self.locations = response.data.warehouses;
        });
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_events__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sass_app_scss__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sass_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_sass_app_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default.a);

window.Event = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 12,
	"./af.js": 12,
	"./ar": 19,
	"./ar-dz": 13,
	"./ar-dz.js": 13,
	"./ar-kw": 14,
	"./ar-kw.js": 14,
	"./ar-ly": 15,
	"./ar-ly.js": 15,
	"./ar-ma": 16,
	"./ar-ma.js": 16,
	"./ar-sa": 17,
	"./ar-sa.js": 17,
	"./ar-tn": 18,
	"./ar-tn.js": 18,
	"./ar.js": 19,
	"./az": 20,
	"./az.js": 20,
	"./be": 21,
	"./be.js": 21,
	"./bg": 22,
	"./bg.js": 22,
	"./bm": 23,
	"./bm.js": 23,
	"./bn": 25,
	"./bn-bd": 24,
	"./bn-bd.js": 24,
	"./bn.js": 25,
	"./bo": 26,
	"./bo.js": 26,
	"./br": 27,
	"./br.js": 27,
	"./bs": 28,
	"./bs.js": 28,
	"./ca": 29,
	"./ca.js": 29,
	"./cs": 30,
	"./cs.js": 30,
	"./cv": 31,
	"./cv.js": 31,
	"./cy": 32,
	"./cy.js": 32,
	"./da": 33,
	"./da.js": 33,
	"./de": 36,
	"./de-at": 34,
	"./de-at.js": 34,
	"./de-ch": 35,
	"./de-ch.js": 35,
	"./de.js": 36,
	"./dv": 37,
	"./dv.js": 37,
	"./el": 38,
	"./el.js": 38,
	"./en-au": 39,
	"./en-au.js": 39,
	"./en-ca": 40,
	"./en-ca.js": 40,
	"./en-gb": 41,
	"./en-gb.js": 41,
	"./en-ie": 42,
	"./en-ie.js": 42,
	"./en-il": 43,
	"./en-il.js": 43,
	"./en-in": 44,
	"./en-in.js": 44,
	"./en-nz": 45,
	"./en-nz.js": 45,
	"./en-sg": 46,
	"./en-sg.js": 46,
	"./eo": 47,
	"./eo.js": 47,
	"./es": 51,
	"./es-do": 48,
	"./es-do.js": 48,
	"./es-mx": 49,
	"./es-mx.js": 49,
	"./es-us": 50,
	"./es-us.js": 50,
	"./es.js": 51,
	"./et": 52,
	"./et.js": 52,
	"./eu": 53,
	"./eu.js": 53,
	"./fa": 54,
	"./fa.js": 54,
	"./fi": 55,
	"./fi.js": 55,
	"./fil": 56,
	"./fil.js": 56,
	"./fo": 57,
	"./fo.js": 57,
	"./fr": 60,
	"./fr-ca": 58,
	"./fr-ca.js": 58,
	"./fr-ch": 59,
	"./fr-ch.js": 59,
	"./fr.js": 60,
	"./fy": 61,
	"./fy.js": 61,
	"./ga": 62,
	"./ga.js": 62,
	"./gd": 63,
	"./gd.js": 63,
	"./gl": 64,
	"./gl.js": 64,
	"./gom-deva": 65,
	"./gom-deva.js": 65,
	"./gom-latn": 66,
	"./gom-latn.js": 66,
	"./gu": 67,
	"./gu.js": 67,
	"./he": 68,
	"./he.js": 68,
	"./hi": 69,
	"./hi.js": 69,
	"./hr": 70,
	"./hr.js": 70,
	"./hu": 71,
	"./hu.js": 71,
	"./hy-am": 72,
	"./hy-am.js": 72,
	"./id": 73,
	"./id.js": 73,
	"./is": 74,
	"./is.js": 74,
	"./it": 76,
	"./it-ch": 75,
	"./it-ch.js": 75,
	"./it.js": 76,
	"./ja": 77,
	"./ja.js": 77,
	"./jv": 78,
	"./jv.js": 78,
	"./ka": 79,
	"./ka.js": 79,
	"./kk": 80,
	"./kk.js": 80,
	"./km": 81,
	"./km.js": 81,
	"./kn": 82,
	"./kn.js": 82,
	"./ko": 83,
	"./ko.js": 83,
	"./ku": 84,
	"./ku.js": 84,
	"./ky": 85,
	"./ky.js": 85,
	"./lb": 86,
	"./lb.js": 86,
	"./lo": 87,
	"./lo.js": 87,
	"./lt": 88,
	"./lt.js": 88,
	"./lv": 89,
	"./lv.js": 89,
	"./me": 90,
	"./me.js": 90,
	"./mi": 91,
	"./mi.js": 91,
	"./mk": 92,
	"./mk.js": 92,
	"./ml": 93,
	"./ml.js": 93,
	"./mn": 94,
	"./mn.js": 94,
	"./mr": 95,
	"./mr.js": 95,
	"./ms": 97,
	"./ms-my": 96,
	"./ms-my.js": 96,
	"./ms.js": 97,
	"./mt": 98,
	"./mt.js": 98,
	"./my": 99,
	"./my.js": 99,
	"./nb": 100,
	"./nb.js": 100,
	"./ne": 101,
	"./ne.js": 101,
	"./nl": 103,
	"./nl-be": 102,
	"./nl-be.js": 102,
	"./nl.js": 103,
	"./nn": 104,
	"./nn.js": 104,
	"./oc-lnc": 105,
	"./oc-lnc.js": 105,
	"./pa-in": 106,
	"./pa-in.js": 106,
	"./pl": 107,
	"./pl.js": 107,
	"./pt": 109,
	"./pt-br": 108,
	"./pt-br.js": 108,
	"./pt.js": 109,
	"./ro": 110,
	"./ro.js": 110,
	"./ru": 111,
	"./ru.js": 111,
	"./sd": 112,
	"./sd.js": 112,
	"./se": 113,
	"./se.js": 113,
	"./si": 114,
	"./si.js": 114,
	"./sk": 115,
	"./sk.js": 115,
	"./sl": 116,
	"./sl.js": 116,
	"./sq": 117,
	"./sq.js": 117,
	"./sr": 119,
	"./sr-cyrl": 118,
	"./sr-cyrl.js": 118,
	"./sr.js": 119,
	"./ss": 120,
	"./ss.js": 120,
	"./sv": 121,
	"./sv.js": 121,
	"./sw": 122,
	"./sw.js": 122,
	"./ta": 123,
	"./ta.js": 123,
	"./te": 124,
	"./te.js": 124,
	"./tet": 125,
	"./tet.js": 125,
	"./tg": 126,
	"./tg.js": 126,
	"./th": 127,
	"./th.js": 127,
	"./tk": 128,
	"./tk.js": 128,
	"./tl-ph": 129,
	"./tl-ph.js": 129,
	"./tlh": 130,
	"./tlh.js": 130,
	"./tr": 131,
	"./tr.js": 131,
	"./tzl": 132,
	"./tzl.js": 132,
	"./tzm": 134,
	"./tzm-latn": 133,
	"./tzm-latn.js": 133,
	"./tzm.js": 134,
	"./ug-cn": 135,
	"./ug-cn.js": 135,
	"./uk": 136,
	"./uk.js": 136,
	"./ur": 137,
	"./ur.js": 137,
	"./uz": 139,
	"./uz-latn": 138,
	"./uz-latn.js": 138,
	"./uz.js": 139,
	"./vi": 140,
	"./vi.js": 140,
	"./x-pseudo": 141,
	"./x-pseudo.js": 141,
	"./yo": 142,
	"./yo.js": 142,
	"./zh-cn": 143,
	"./zh-cn.js": 143,
	"./zh-hk": 144,
	"./zh-hk.js": 144,
	"./zh-mo": 145,
	"./zh-mo.js": 145,
	"./zh-tw": 146,
	"./zh-tw.js": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(260),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-764dceae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(259),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(256),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7693c3e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(254),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(266),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9709750",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4599b57e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(241),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(262),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-687c5a77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(247),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-183985ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ors-time-and-date"
  }, _vm._l((_vm.orderParts), function(parcel, index) {
    return _c('div', {
      staticClass: "col-auto col-divided"
    }, [_c('strong', [_vm._v(_vm._s(parcel.ordNumber))]), _c('em', [_vm._v(_vm._s(_vm._f("toFixed")(parcel.ordValue)) + " zł")])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-bookmark header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Nr zamówień")])])
}]}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.email),
      expression: "order.buyer.email"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.email",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.phone),
      expression: "order.buyer.phone"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.phone",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.firstName),
      expression: "order.buyer.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.firstName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "buyer.language",
      "maxlength": "50",
      "value": "pl"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.description),
      expression: "order.description"
    }],
    attrs: {
      "type": "text",
      "name": "description",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.extOrderId),
      expression: "order.extOrderId"
    }],
    attrs: {
      "type": "text",
      "name": "extOrderId",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.extOrderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "extOrderId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.totalAmount),
      expression: "order.totalAmount"
    }],
    attrs: {
      "type": "text",
      "name": "totalAmount",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.totalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "totalAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.language),
      expression: "order.language"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.language",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "language", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.notifyUrl),
      expression: "order.notifyUrl"
    }],
    attrs: {
      "type": "text",
      "name": "notifyUrl",
      "value": ""
    },
    domProps: {
      "value": (_vm.order.notifyUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "notifyUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.customerIp),
      expression: "order.customerIp"
    }],
    attrs: {
      "type": "text",
      "name": "customerIp",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.order.customerIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "customerIp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.merchantPosId),
      expression: "order.merchantPosId"
    }],
    attrs: {
      "type": "text",
      "name": "merchantPosId",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.order.merchantPosId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "merchantPosId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.currencyCode),
      expression: "order.currencyCode"
    }],
    attrs: {
      "type": "text",
      "name": "currencyCode",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.currencyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "currencyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.continueUrl),
      expression: "order.continueUrl"
    }],
    attrs: {
      "type": "text",
      "name": "continueUrl"
    },
    domProps: {
      "value": (_vm.order.continueUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "continueUrl", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-map"
  }), _vm._v(" "), _c('h2', [_vm._v("Planowana trasa")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "address-map"
    }
  })])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "distance-info"
  }, [_c('b', [_vm._v("Mapa testowa")]), _vm._v(" | Dystans z google: " + _vm._s(_vm.googleDistance) + " Km poza strefą:" + _vm._s(_vm.kmOutZone))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "border": "solid 2px #000",
      "width": "100%",
      "height": "100px"
    }
  }, [_vm._v(_vm._s(_vm.circleTxt))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "call-center-map"
  }, [_c('div', {
    attrs: {
      "id": "myMap"
    }
  })])
}]}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vendor-agata-location-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-vendor-information"
  }, [_c('div', {
    staticClass: "option-container main-option-container"
  }, _vm._l((_vm.locations), function(loc, i) {
    return _c('div', {
      key: i,
      staticClass: "option4",
      class: {
        'option-active': loc.ID == _vm.locationId
      },
      on: {
        "click": function($event) {
          return _vm.setWarehouse(loc)
        }
      }
    }, [_c('p', {
      class: [loc.cssClass],
      domProps: {
        "innerHTML": _vm._s(loc.City)
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warehouseError === true),
      expression: "warehouseError === true"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór salonu z dostępnej listy.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header mb-20"
  }, [_c('i', {
    staticClass: "ion-location"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz salon Agata Meble")])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "container-new-clean info-block center-text",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('i', {
    staticClass: "ion-android-checkmark-circle",
    staticStyle: {
      "font-size": "60px",
      "color": "#008ce8",
      "line-height": "0px",
      "margin-right": "0px"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Dziękujemy za złożenie zamówienia!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#ff3f00"
    }
  }, [_vm._v("Link do płatności:")]), _vm._v(" "), _c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payuUrl),
      expression: "payuUrl"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payuUrl = $event.target.value
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Wkrótce otrzymasz mail potwierdzający, wraz z linkiem do płatności online."), _c('br'), _vm._v("W przypadku ewentualnych problemów skontaktuj się z nami: "), _c('a', {
    attrs: {
      "href": "mailto:callcenter@dts.pl"
    }
  }, [_vm._v("callcenter@dts.pl")]), _c('br'), _vm._v("Dziękujemy i życzymy miłego dnia!")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.orderData.warehouse) ? _c('div', {
    staticClass: "ors-time-and-date"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Punkt podjęcia:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.warehouse.Name) + " "), _c('br'), _vm._v(_vm._s(_vm.orderData.warehouse.Street) + " " + _vm._s(_vm.orderData.warehouse.StreetNo)), _c('br'), _vm._v("\n            " + _vm._s(_vm.orderData.warehouse.PostalCode) + " " + _vm._s(_vm.orderData.warehouse.City))])]), _vm._v(" "), (_vm.step > 2) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Adres realizacji:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.address.Street) + " " + _vm._s(_vm.orderData.address.StreetNo) + " "), (_vm.orderData.address.ApartmentNo) ? _c('span', [_vm._v("/ " + _vm._s(_vm.orderData.address.ApartmentNo))]) : _vm._e(), (_vm.orderData.address.FloorNo) ? _c('span', [_vm._v(" (" + _vm._s(_vm.orderData.address.FloorNo) + " piętro)")]) : _vm._e(), _c('br'), _vm._v(_vm._s(_vm.orderData.address.PostalCode) + " " + _vm._s(_vm.orderData.address.City))])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Preferowany dzień dostawy:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.date.date))])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Przedział godzinowy:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.timePeriod))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distance),
      expression: "orderData.delivery.distance"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.distance))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distanceOutOfZone),
      expression: "orderData.delivery.distanceOutOfZone"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans poza strefą:")]), _c('em', [_vm._v(_vm._s(_vm._f("formatDistance")(_vm.orderData.delivery.distanceOutOfZone)) + " km")])]), _vm._v(" "), (_vm.step > 3) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Dane klienta:")]), _vm._v(" "), _c('em', [_c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.FirstName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.LastName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.MobilePhone)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.Email) + "\n            ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-android-checkbox-outline header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Podsumowanie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Typ usługi:")]), _c('em', [_vm._v("Transport")])])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new right-info-block",
    attrs: {
      "id": "order-help-section"
    }
  }, [_c('i', {
    staticClass: "ion-ios-information-outline"
  }), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }]
  }, [_vm._v("Punkt podjęcia")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wybierz salon podjęcia dostępny z widocznej obok listy, następnie przejdź dalej")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }]
  }, [_vm._v("Adres realizacji")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.")]), _vm._v(" "), _c('p', [_vm._v("Przed przejściem dalej sprawdź poprawność danych.")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }]
  }, [_vm._v("Szczegóły")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk \"Dodaj\". Krok ten jest niezbędny do obliczenia kosztów transportu.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("W przypadku większej ilości zamówień dodaj kolejne zamówienia postepując zgodnie z pkt. 1.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("3")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowaną datę realizacji spośród dostępnych terminów. W przypadku wyboru innego terminu realizacji, wybierz opcję \"Inny termin\", a następnie wpisz preferowany termin realizacji.")]), _vm._v(" "), _c('p', [_vm._v("UWAGA! Podane terminy są najbliższymi możliwymi")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("4")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowany przedział godzinowy dostawy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("5")]), _vm._v(" "), _c('p', [_vm._v("Po uzupełnieniu wszystkich danych przejdź dalej do podsumowania.")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }]
  }, [_vm._v("Podsumowanie")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Prosimy o sprawdzenie poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia wraz z linkiem do płatności.")]), _vm._v(" "), _c('p', [_vm._v("Jeśli wszystkie wprowadzone przez Ciebie dane zgadzają się, możesz zakończyć proces rejestracji zamówienia dostawy. W przeciągu 5 minut otrzymasz potwierdzenie smsowe, a także mail z podsumowaniem zamówienia zawierający link do płatności online, dzięki któremu będziesz mógł dokonać opłaty za transport w wygodny dla siebie sposób.")]), _vm._v(" "), _c('p', [_vm._v("Dziękujemy za skorzystanie z usług DTS i życzymy miłego dnia!")])])])
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-new right-info-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header mb-10"
  }, [_c('i', {
    staticClass: "ion-android-locate header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybrany punkt podjęcia")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "290px"
    },
    attrs: {
      "id": "first-step-map"
    }
  })])])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "added-order-numbers"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.orderParts), function(parcel, index) {
    return _c('div', {
      staticClass: "order-single-line"
    }, [_c('h4', {
      attrs: {
        "id": "lp"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h4', {
      attrs: {
        "id": "order-number"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordNumber),
        expression: "parcel.ordNumber"
      }],
      staticClass: "order-number-add-field",
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "onfocus": "(this.value == 'Wpisz numer zamówienia') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz numer zamówienia')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "id": "order-value"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordValue),
        expression: "parcel.ordValue"
      }],
      staticClass: "order-price-add-field",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "value": "Wpisz wartość zamówienia",
        "onfocus": "(this.value == 'Wpisz wartość zamówienia') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz wartość zamówienia')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordValue", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "width": "75px"
      },
      attrs: {
        "id": "order-weight"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordWeight),
        expression: "parcel.ordWeight"
      }],
      staticClass: "order-price-add-field",
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "value": "Wpisz wagę przesyłki",
        "onfocus": "(this.value == 'Wpisz wagę przesyłki') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz wagę przesyłki')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "ion-android-cancel clickable",
      on: {
        "click": function($event) {
          return _vm.removePart(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('i', {
    staticClass: "ion-android-add-circle color-blue clickable",
    on: {
      "click": function($event) {
        return _vm.addPart()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-single-line header-single-line"
  }, [_c('h4', {
    attrs: {
      "id": "lp"
    }
  }, [_vm._v("SUMA")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "150px"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "'width": "100px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.partsValueSum) + " zł\n                ")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.partsWeightSum) + " kg\n                ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderPartErrorNum),
      expression: "orderPartErrorNum"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "validation-for": "name5"
    }
  }, [_vm._v("\n                Prosimy o wpisanie numeru zamówienia.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderPartErrorValue),
      expression: "orderPartErrorValue"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "validation-for": "name6"
    }
  }, [_vm._v("\n                Prosimy o wpisanie wartości zamówienia.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryParcelsError),
      expression: "deliveryParcelsError"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("\n                Prosimy o dodanie przynajmniej jednego numeru zamówienia\n                wraz z jego wartością\n            ")]), _vm._v(" "), _c('p')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-bookmark"
  }), _vm._v(" "), _c('h2', [_vm._v("Dodaj numery i wartości zamówień")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-single-line header-single-line"
  }, [_c('h4', {
    attrs: {
      "id": "lp"
    }
  }, [_vm._v("Lp")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "order-number"
    }
  }, [_vm._v("Nr zamówienia")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("Wartość")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("Waga")])])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.Street),
      expression: "address.Street"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.showFieldsError.Street == true
    },
    attrs: {
      "type": "text",
      "autocomplete": "street-address",
      "name": "Ulica",
      "onfocus": "(this.value == 'Ulica') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Ulica')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.Street)
    },
    on: {
      "keyup": _vm.geocodeAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "Street", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.StreetNo),
      expression: "address.StreetNo"
    }],
    staticClass: "contactField order-field-name",
    class: {
      'error-field': _vm.showFieldsError.StreetNo == true
    },
    attrs: {
      "type": "text",
      "onfocus": "(this.value == 'Nr budynku') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Nr budynku')",
      "name": "Nr budynku",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.StreetNo)
    },
    on: {
      "keyup": _vm.geocodeAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "StreetNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.ApartmentNo),
      expression: "address.ApartmentNo"
    }],
    staticClass: "contactField order-field-name",
    class: {
      'error-field': _vm.fieldsError.ApartmentNo == true
    },
    attrs: {
      "type": "text",
      "placeholder": "Nr lokalu",
      "name": "Nr lokalu",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.ApartmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "ApartmentNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.City),
      expression: "address.City"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.showFieldsError.City == true
    },
    attrs: {
      "type": "text",
      "onfocus": "(this.value == 'Miejscowość') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Miejscowość')",
      "name": "Miejscowosc",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.City)
    },
    on: {
      "keyup": _vm.geocodeAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "City", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.PostalCode),
      expression: "address.PostalCode"
    }],
    staticClass: "contactField order-field-name",
    class: {
      'error-field': _vm.showFieldsError.PostalCode == true
    },
    attrs: {
      "type": "text",
      "autocomplete": "postal-code",
      "maxlength": "6",
      "onfocus": "(this.value == 'Kod pocztowy') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Kod pocztowy')",
      "name": "Kod-pocztowy",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.PostalCode)
    },
    on: {
      "keyup": _vm.geocodeAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "PostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.FloorNo),
      expression: "address.FloorNo"
    }],
    staticClass: "contactField order-field-name",
    class: {
      'error-field': _vm.showFieldsError.FloorNo == true
    },
    attrs: {
      "type": "text",
      "onfocus": "(this.value == 'Piętro') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Piętro')",
      "name": "Pietro",
      "id": "Number"
    },
    domProps: {
      "value": (_vm.address.FloorNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "FloorNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddressError),
      expression: "showAddressError"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o uzupełnienie wszystkich niezbędnych pól.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFieldsError.PostalCode),
      expression: "showFieldsError.PostalCode"
    }],
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wpisanie poprawnego kodu pocztowego według formatu \"00-000\".")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-home"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz adres realizacji")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-information-circled header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Pomoc")])]), _vm._v(" "), _c('img', {
    staticClass: "right-order-block-img",
    attrs: {
      "src": "https://www.mojadostawa.pl/lib/customerZone/images/ind-main-02.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Jeżeli chciałbyś dokonać ewentualnej zmiany w swoim zamówieniu lub chciałbyś uzyskać więcej informacji o realizowanym zleceniu, skontaktuj sie z nami.")]), _vm._v(" "), _c('p', [_vm._v("Nasi konsultanci są do Twojej stałej dyspozycji pod nr tel.: "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98")]), _vm._v(".")])])])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "id": "order-details"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.parts),
      expression: "deliveryOptionsErrors.parts"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o dodanie przynajmniej jednego numeru zamówienia wraz z jego wartością.")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('div', {
    staticClass: "option-container"
  }, [_vm._l((_vm.threeAvailableDates), function(d, index) {
    return _c('div', {
      staticClass: "option4 order-promoted-option",
      class: {
        'option-active': d.date == _vm.currentDate.date
      },
      on: {
        "click": function($event) {
          return _vm.selectDate(d);
        }
      }
    }, [_c('h5', [_vm._v(_vm._s(d.date))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(d.dayName) + ")")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "option4",
    class: {
      'option-active': _vm.showAllDates == true
    },
    on: {
      "click": function($event) {
        return _vm.clickAllDates()
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.otherDates.date))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.otherDates.note) + ")")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllDates),
      expression: "showAllDates"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selDate),
      expression: "selDate"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selDate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wybierz preferowany dzień dostawy")]), _vm._v(" "), _vm._l((_vm.availableDates), function(d) {
    return _c('option', {
      domProps: {
        "selected": _vm.currentDate,
        "value": d.date
      }
    }, [_vm._v(_vm._s(d.date) + " (" + _vm._s(d.dayName) + ")")])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.date),
      expression: "deliveryOptionsErrors.date"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór preferowanego dnia dostawy.")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('div', {
    staticClass: "option-container"
  }, [_c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[0]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(0);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42,14.1c0,1.7,0.4,3.3,1.2,4.6l8.1-4.7V4.8C46.2,4.8,42,9,42,14.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M51.4,0c-7.8,0-14.2,6.3-14.2,14.1s6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2C65.5,6.3,59.2,0,51.4,0z M60.6,18.6\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.7c-0.2,0.1-0.4,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0v1c-1.6-0.1-3.1-0.6-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-2-3.4-3.3l0.9-0.5c-0.5-0.3-0.8-0.8-1-1.2l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.4\n\t\t\t\t\t\t\t\t\t\t\th-1c0.1-1.6,0.5-3.2,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2l0.5,0.9c0.2-0.1,0.4-0.3,0.7-0.4\n\t\t\t\t\t\t\t\t\t\t\tl-0.5-0.9C47.5,3.6,49,3.1,50.6,3v1c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.7,0V3c1.6,0.1,3.1,0.6,4.5,1.3L56,5.2\n\t\t\t\t\t\t\t\t\t\t\tc0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1\n\t\t\t\t\t\t\t\t\t\t\tc0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4h1c-0.1,1.6-0.5,3.2-1.1,4.6L60.6,18.6z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[1]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(1);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M56.2,6.1c-1.5-0.8-3-1.2-4.6-1.3v9.4l8,4.6C62.2,14.4,60.5,8.6,56.2,6.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M63.7,21.2c3.9-6.8,1.6-15.5-5.2-19.4S43.1,0.3,39.2,7.1c-3.9,6.7-1.6,15.4,5.2,19.3S59.8,28,63.7,21.2z\n\t\t\t\t\t\t\t\t\t\t\t M43,19.9c-0.2-0.4-0.5-0.9-0.7-1.3l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.3,0-0.5,0-0.8h-1c0-1.6,0.4-3.1,1.1-4.6l0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.6l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2L46,5.6c0.2-0.1,0.5-0.3,0.7-0.4l-0.5-0.9\n\t\t\t\t\t\t\t\t\t\t\tC47.5,3.6,49,3.1,50.7,3v1c0.5,0,1,0,1.5,0V3c1.5,0.1,3,0.5,4.5,1.3l-0.5,0.9c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5-0.9c1.4,0.9,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1\n\t\t\t\t\t\t\t\t\t\t\tc0,1.6-0.4,3.1-1.1,4.6l-0.9-0.5c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.6l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.8\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0.1-0.5,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.5-0.1-3-0.5-4.5-1.3l0.5-0.9\n\t\t\t\t\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2l-0.5,0.9c-1.4-0.9-2.5-2-3.4-3.3L43,19.9z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[2]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(2);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M56,22.2c1.5-0.8,2.6-2,3.4-3.4l-8.1-4.7l-8,4.6C45.9,23.3,51.6,24.8,56,22.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4\n\t\t\t\t\t\t\t\t\t\t\tc0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6\n\t\t\t\t\t\t\t\t\t\t\tl-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1\n\t\t\t\t\t\t\t\t\t\t\tc0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[3]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(3);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4\n\t\t\t\t\t\t\t\t\t\t\tc0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6\n\t\t\t\t\t\t\t\t\t\t\tl-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1\n\t\t\t\t\t\t\t\t\t\t\tc0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("08:00 - 20:00")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.period),
      expression: "deliveryOptionsErrors.period"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór preferowanego przedziału godzinowego dostawy.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-calendar"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz preferowany dzień dostawy")]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("UWAGA: Wybrany termin oznacza preferowany dzień dostawy, który może ulec zmianie w toku planowania. W przypadku zaistnienia takiej sytuacji pracownik POK skontaktuje się telefonicznie w celu umówienia ostatecznego terminu realizacji.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-time"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz przedział godzinowy dostawy")])])
}]}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "order-price-section"
    }
  }, [_c('div', {
    staticClass: "container-new",
    staticStyle: {
      "text-align": "left",
      "overflow": "visible",
      "height": "195px"
    }
  }, [_c('div', {
    staticClass: "order-right-info"
  }, [_c('div', {
    staticClass: "order-price"
  }, [_c('h2', [_vm._v("Koszt dostawy:")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.deliveryCost) + " zł")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCostInput === true),
      expression: "showCostInput === true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manualDeliveryCost),
      expression: "manualDeliveryCost"
    }],
    staticStyle: {
      "border": "solid 1px #ddd",
      "padding": "4px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.manualDeliveryCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manualDeliveryCost = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cpointer",
    on: {
      "click": function($event) {
        return _vm.changeCost()
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryCostError),
      expression: "deliveryCostError"
    }],
    staticClass: "error-message"
  }, [_vm._v("Nie udało się przeliczyć kosztów dostawy. Skontaktuj się z działem Call Center pod adresem mailowym callcenter@dts.pl.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "margin-top": "60px",
      "text-align": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showChangeCostInput()
      }
    }
  }, [_vm._v("Zmień koszt")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Koszt dostawy zawiera:")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" wniesienie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" rozpakowanie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" ustawienie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" drobny montaż"), _c('a', {
    attrs: {
      "href": "#",
      "data-tooltip": "Dokonanie drobnego montażu mebli w postaci : przykręcenia okuć mebla, przykręcenia boczków wersalek, narożników i foteli (z wyłączeniem finki oraz mebli w przypadku których jest potrzebna ingerencja w tapicerkę), montażu podnóżek, nóżek, stopek, listew ozdobnych do kanap i narożników, montaż kanap typu DL, montaż wezgłowia do łóżek typu RELAX, montaż zaczepów do narożników i łączenie elementów narożnika w całość. Drobny montaż nie obejmuje demontażu mebla w celu wniesienia do lokalu Klienta. Usługa drobnego montażu obejmuje powyższy zakres prac, przy założeniu, iż czas jej realizacji nie powinien zająć pracownikom więcej niż 15 minut na pojedynczy mebel."
    }
  }, [_vm._v(" [?]")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" wyrzucenie opakowań\n                ")])
}]}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap_all"
    }
  }, [_c('header', {
    staticClass: "all_colors header_color light_bg_color av_header_top av_logo_left av_main_nav_header av_menu_right av_slim av_header_sticky av_header_shrinking_disabled av_header_stretch av_mobile_menu_tablet av_header_searchicon_disabled av_header_unstick_top_disabled av_minimal_header av_bottom_nav_disabled av_header_border_disabled",
    attrs: {
      "id": "header",
      "role": "banner",
      "itemscope": "itemscope",
      "itemtype": "https://schema.org/WPHeader"
    }
  }, [_c('div', {
    staticClass: "container_wrap container_wrap_logo",
    attrs: {
      "id": "header_main"
    }
  }, [_c('div', {
    staticClass: "container av-logo-container"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('span', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 595.28"
    },
    attrs: {
      "version": "1.1",
      "id": "Warstwa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 595.28 99.6",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M55.81,78.12v19.53H0V83.7l26.37-36.27H1.4V27.9h53.01v13.95L28.04,78.12H55.81z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M135.77,27.9v69.75h-20.93V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83\n      c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V27.9H135.77z M114.84,62.77c0-10.46-6.97-17.02-16.6-17.02\n      s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S114.84,73.24,114.84,62.77z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M222.72,0v97.65H201.8V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83\n      c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V0H222.72z M201.8,62.77c0-10.46-6.97-17.02-16.6-17.02\n      s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S201.8,73.24,201.8,62.77z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M313.17,62.77c0,20.79-15.07,36.83-33.34,36.83c-9.35,0-16.18-3.21-20.79-8.51v6.55h-20.92V0h20.92v34.46\n      c4.61-5.3,11.44-8.51,20.79-8.51C298.1,25.95,313.17,41.99,313.17,62.77z M292.24,62.77c0-10.46-6.97-17.02-16.6-17.02\n      s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02S292.24,73.24,292.24,62.77z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M396.64,27.9v69.75h-20.93V91.1c-4.6,5.3-11.44,8.51-20.79,8.51c-18.27,0-33.34-16.04-33.34-36.83\n      c0-20.78,15.07-36.83,33.34-36.83c9.35,0,16.19,3.21,20.79,8.51V27.9H396.64z M375.71,62.77c0-10.46-6.97-17.02-16.6-17.02\n      s-16.6,6.55-16.6,17.02s6.97,17.02,16.6,17.02C368.74,79.8,375.71,73.24,375.71,62.77z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M478.98,54.82v42.83h-20.92V57.9c0-8.65-5.44-12.7-12.14-12.7c-7.67,0-12.98,4.46-12.98,14.37v38.09h-20.92\n      V27.9h20.92v6.55c3.77-5.16,10.75-8.51,19.95-8.51C466.99,25.95,478.98,35.99,478.98,54.82z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M489.91,62.77c0-20.78,16.46-36.83,36.97-36.83s36.97,16.04,36.97,36.83S547.39,99.6,526.88,99.6\n      C506.37,99.61,489.91,83.56,489.91,62.77z M542.92,62.77c0-9.9-6.98-16.46-16.04-16.46c-9.07,0-16.04,6.55-16.04,16.46\n      s6.97,16.46,16.04,16.46C535.94,79.24,542.92,72.68,542.92,62.77z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M568.77,86.35c0-7.25,6-13.25,13.26-13.25c7.25,0,13.25,6,13.25,13.25c0,7.26-6,13.26-13.25,13.26\n      C574.77,99.61,568.77,93.61,568.77,86.35z"
    }
  })])])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "header_bg"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "main_menu",
    attrs: {
      "data-selectname": "Wybierz stornę",
      "role": "navigation",
      "itemscope": "itemscope",
      "itemtype": "https://schema.org/SiteNavigationElement"
    }
  }, [_c('div', {
    staticClass: "avia-menu av-main-nav-wrap"
  }, [_c('ul', {
    staticClass: "menu av-main-nav",
    attrs: {
      "id": "avia-menu"
    }
  }, [_c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-1",
    attrs: {
      "id": "menu-item-47"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/o-nas/",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("O nas")]), _c('span', {
    staticClass: "avia-menu-fx"
  }, [_c('span', {
    staticClass: "avia-arrow-wrap"
  }, [_c('span', {
    staticClass: "avia-arrow"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-top-level menu-item-top-level-2 dropdown_ul_available",
    attrs: {
      "id": "menu-item-48"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "default"
    },
    attrs: {
      "href": "#",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Oferta dla biznesu")]), _c('span', {
    staticClass: "avia-menu-fx"
  }, [_c('span', {
    staticClass: "avia-arrow-wrap"
  }, [_c('span', {
    staticClass: "avia-arrow"
  })])]), _c('span', {
    staticClass: "dropdown_available"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu",
    staticStyle: {
      "display": "block",
      "opacity": "0",
      "visibility": "hidden"
    }
  }, [_c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page",
    attrs: {
      "id": "menu-item-51"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/uslugi/",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Usługi")])])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page",
    attrs: {
      "id": "menu-item-50"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/rozwiazania/",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Rozwiązania")])])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page",
    attrs: {
      "id": "menu-item-49"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/wspolpraca/",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Współpraca")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-3",
    attrs: {
      "id": "menu-item-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/kontakt/",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Kontakt")]), _c('span', {
    staticClass: "avia-menu-fx"
  }, [_c('span', {
    staticClass: "avia-arrow-wrap"
  }, [_c('span', {
    staticClass: "avia-arrow"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-custom menu-item-object-custom av-menu-button av-menu-button-colored menu-item-top-level menu-item-top-level-4",
    attrs: {
      "id": "menu-item-53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "itemprop": "url"
    }
  }, [_c('span', {
    staticClass: "avia-bullet"
  }), _c('span', {
    staticClass: "avia-menu-text"
  }, [_vm._v("Szczegóły zlecenia")]), _c('span', {
    staticClass: "avia-menu-fx"
  }, [_c('span', {
    staticClass: "avia-arrow-wrap"
  }, [_c('span', {
    staticClass: "avia-arrow"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "av-burger-menu-main menu-item-avia-special"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Menu",
      "aria-hidden": "false"
    }
  }, [_c('span', {
    staticClass: "av-hamburger av-hamburger--spin av-js-hamburger"
  }, [_c('span', {
    staticClass: "av-hamburger-box"
  }, [_c('span', {
    staticClass: "av-hamburger-inner"
  }), _vm._v(" "), _c('strong', [_vm._v("Menu")])])]), _vm._v(" "), _c('span', {
    staticClass: "avia_hidden_link_text"
  }, [_vm._v("Menu")])])])])])])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup",
    on: {
      "click": function($event) {
        return _vm.hideMe()
      }
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_c('p', [_vm._v("Wprowadzone przez Ciebie dane zostały już zarejestrowane w naszym systemie. W celu ich zmiany skontaktuj się z działem Call Center pod numerem telefonu:"), _c('br'), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98.")])]), _vm._v(" "), _c('i', {
    staticClass: "ion-android-close"
  })])
}]}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-new right-info-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header mb-20"
  }, [_c('i', {
    staticClass: "ion-information-circled header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.headings[_vm.step]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Niniejszy formularz rejestracyjny pozwoli Ci na zamówienie kompleksowej usługi transportowej, a także dokonanie płatności online w wygodny dla Ciebie sposób.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Wybierz salon podjęcia z dostępnej listy, następnie przejdź dalej uprzednio sprawdzając poprawność dokonanego wyboru na mapie dostępniej poniżej.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Przed przejściem dalej sprawdź poprawność wprowadzonych danych.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk \"Dalej\".")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowaną datę realizacji spośród dostępnych terminów.")]), _vm._v(" "), _c('p', [_vm._v("W przypadku wyboru innego terminu realizacji, wybierz opcję \"Inny termin\", a następnie wybierz preferowany termin realizacji z dostępnej listy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Wybierz preferowany przedział godzinowy dostawy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Prosimy o sprawdzenie w podsumowaniu poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia, a także przyszłe powiadomienia o statusie zlecenia.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("Jeżeli chcesz zmienić dane do faktury VAT, skorzystaj z opcji \"Zmień dane do faktury\".")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Aby dokonać zamówienia usługi transportowej skorzystaj z opcji \"Zamawiam\". W przypadku, gdy Twoje zamówienie zostało już opłacone online lub stacjonarnie w salonie meblowym Agata, skorzystaj z opcji \"Zamawiam (zapłacone)\". Jeśli nie opłaciłeś jeszcze swojego zamówienia, wybierz opcję \"Zamawiam (płacę)\" w celu przejścia do wyboru płatności online.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Postępuj zgodnie z instrukcjami dostępnymi w niniejszej części formularza. W razie napotkania jakichkolwiek problemów nasi konsultanci są do Twojej dyspozycji pod nr tel.: "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("W przypadku większej ilości zamówień dodaj kolejne zamówienie wciskając przycisk "), _c('i', {
    staticClass: "ion-android-add-circle color-blue"
  }), _vm._v(" i postępuj zgodnie z pkt.1. Aby usunąć niechciane zamówienie wciśnij przycisk "), _c('i', {
    staticClass: "ion-android-cancel color-gray"
  }), _vm._v(".")])
}]}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-progress"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 1 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Punkt podjęcia")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 2 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("Adres realizacji")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 3 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("3")]), _vm._v(" "), _c('p', [_vm._v("Numery zamówień")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 4 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("4")]), _vm._v(" "), _c('p', [_vm._v("Termin dostawy")])]), _vm._v(" "), _c('div', {
    staticClass: "order-progress-element",
    class: _vm.step == 5 || _vm.step == 6 ? 'active-element' : 'inactive-element'
  }, [_c('h2', [_vm._v("5")]), _vm._v(" "), _c('p', [_vm._v("Podsumowanie")])])])
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-vendor-information"
  }, [_c('div', {
    staticClass: "option-container main-option-container"
  }, [_c('div', {
    staticClass: "option2",
    class: {
      'option-active': _vm.delivery.withCarry == 1
    },
    on: {
      "click": function($event) {
        return _vm.setDeliveryType(1)
      }
    }
  }, [_c('p', [_vm._v("Dostawa z wniesieniem")])]), _vm._v(" "), _c('div', {
    staticClass: "option2",
    class: {
      'option-active': _vm.delivery.withCarry == 0
    },
    on: {
      "click": function($event) {
        return _vm.setDeliveryType(0)
      }
    }
  }, [_c('p', [_vm._v("Dostawa bez wniesienia")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header mb-20"
  }, [_c('i', {
    staticClass: "ion-gear-a"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz rodzaj dostawy")])])
}]}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.orderData.warehouse) ? _c('div', {
    staticClass: "ors-time-and-date"
  }, [_c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Punkt podjęcia:")]), _vm._v(" "), _c('em', [_vm._v("Agata Meble - " + _vm._s(_vm.orderData.warehouse.City) + "\n            "), _c('br'), _vm._v(_vm._s(_vm.orderData.warehouse.Street) + " " + _vm._s(_vm.orderData.warehouse.StreetNo)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.warehouse.PostalCode) + " " + _vm._s(_vm.orderData.warehouse.City) + "\n            ")])]), _vm._v(" "), (_vm.step > 2) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Adres realizacji:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.address.Street) + " " + _vm._s(_vm.orderData.address.StreetNo)), _c('br'), _vm._v(_vm._s(_vm.orderData.address.PostalCode) + " " + _vm._s(_vm.orderData.address.City))])]) : _vm._e(), _vm._v(" "), (_vm.step > 2 && _vm.orderData.delivery.zoneName) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Strefa transportowa:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.zoneName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distance),
      expression: "orderData.delivery.distance"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.distance) + " km")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-nav-section"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "order-button orderCancelButton",
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_c('i', {
    staticClass: "ion-android-close"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step > 1),
      expression: "step > 1"
    }],
    staticClass: "order-button order-button-left orderSubmitButton",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        return _vm.decreseStep();
      }
    }
  }, [_c('h5', [_vm._v("Wstecz")])]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step < 6),
      expression: "step < 6"
    }]
  }, [_vm._v("Krok " + _vm._s(_vm.step) + "/" + _vm._s(_vm.stepsCount))]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step >= 6),
      expression: "step >= 6"
    }]
  }, [_vm._v(" ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step < 5),
      expression: "step < 5"
    }],
    staticClass: "order-button order-button-right orderSubmitButton",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        return _vm.setStep();
      }
    }
  }, [_c('h5', [_vm._v("Dalej")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 6 && _vm.orderType == 'orderToPay'),
      expression: "step == 6 && orderType == 'orderToPay'"
    }],
    staticClass: "order-button orderSubmitButton",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        return _vm.pay();
      }
    }
  }, [_c('h5', [_vm._v("Zapłać z PayU")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "order-button orderSubmitButton",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        return _vm.makeOrder('orderToPay');
      }
    }
  }, [_c('h5', [_vm._v("Zamawiam - link do płatności")])])])])
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageMenu'), _vm._v(" "), _c('div', {
    staticClass: "zaplac",
    attrs: {
      "id": "app-main"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.token),
      expression: "!token"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "min-height": "400px",
      "flex-direction": "column"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "5rem"
    }
  }, [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "19px",
      "padding-top": "12px"
    }
  }, [_vm._v("\n                Nieprawidłowy adres strony\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "min-height": "400px",
      "flex-direction": "column"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "2rem"
    }
  }, [_vm._v("UWAGA!")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorReason === 'already_paid'),
      expression: "errorReason === 'already_paid'"
    }],
    staticStyle: {
      "font-size": "1"
    }
  }, [_vm._v("\n                Płatność zakończona pomyślnie\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorReason === 'no_valid_token'),
      expression: "errorReason === 'no_valid_token'"
    }],
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("\n                Adres strony jest nieprawidłowy\n            ")])]), _vm._v(" "), _c('div', [(_vm.errorReason === '') ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "desktop-order-summary"
  }, [_c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Nadawca")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.orderData.customer.FirstName) + "\n                            " + _vm._s(_vm.orderData.customer.LastName) + "\n                        ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Kwota do zapłaty")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + "\n                            " + _vm._s(_vm.orderData.delivery.currencyCode) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "bold",
      "color": "#fff",
      "padding": "1rem 1.5rem",
      "cursor": "pointer",
      "background-color": "#00d6ff"
    },
    on: {
      "click": function($event) {
        return _vm.startPayment()
      }
    }
  }, [_vm._v("Zapłać")])])]), _vm._v(" "), _c('PageFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "section-header no-icon"
  }, [_c('h1', [_vm._v("Zamówienie usługi transportowej")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Odbiorca")]), _vm._v(" "), _c('p', [_vm._v("DTS Transport Sp. z o.o.")]), _vm._v(" "), _c('p', [_vm._v("ul. Wał Miedzeszyński 251,")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Forma płatności")]), _vm._v(" "), _c('p', [_vm._v("Przelew online")])])
}]}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap_all"
    }
  }, [_c('div', {
    staticClass: "container_wrap footer_color",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex_column av_one_fourth first el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_text",
    attrs: {
      "id": "text-3"
    }
  }, [_c('div', {
    staticClass: "textwidget"
  }, [_c('p', [_c('a', {
    staticClass: "alignnone",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "position": "relative",
      "overflow": "hidden"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "alignnone size-full wp-image-266",
    attrs: {
      "loading": "lazy",
      "src": "https://zadbano.pl/wp-content/uploads/2021/01/logo-blue.png",
      "alt": "",
      "width": "300",
      "height": "50"
    }
  }), _c('span', {
    staticClass: "image-overlay overlay-type-extern"
  }, [_c('span', {
    staticClass: "image-overlay-inside"
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget_text widget clearfix widget_custom_html",
    attrs: {
      "id": "custom_html-3"
    }
  }, [_c('div', {
    staticClass: "textwidget custom-html-widget"
  }), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_text",
    attrs: {
      "id": "text-2"
    }
  }, [_c('div', {
    staticClass: "textwidget"
  }, [_c('p', [_vm._v("ul. Wał Miedzeszyński 251")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:kontakt@zadbano.pl"
    }
  }, [_vm._v("kontakt@zadbano.pl")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+48225261000"
    }
  }, [_vm._v("+48 22 526 1000")])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_nav_menu",
    attrs: {
      "id": "nav_menu-2"
    }
  }, [_c('div', {
    staticClass: "menu-footer-menu-container"
  }, [_c('ul', {
    staticClass: "menu",
    attrs: {
      "id": "menu-footer-menu"
    }
  }, [_c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-156",
    attrs: {
      "id": "menu-item-156"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/o-nas/"
    }
  }, [_vm._v("O nas")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-157",
    attrs: {
      "id": "menu-item-157"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/uslugi/"
    }
  }, [_vm._v("Usługi")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-158",
    attrs: {
      "id": "menu-item-158"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/rozwiazania/"
    }
  }, [_vm._v("Rozwiązania")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-159",
    attrs: {
      "id": "menu-item-159"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/wspolpraca/"
    }
  }, [_vm._v("Współpraca")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-160",
    attrs: {
      "id": "menu-item-160"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/regulaminy-i-dokumenty/"
    }
  }, [_vm._v("Regulaminy i dokumenty")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-161",
    attrs: {
      "id": "menu-item-161"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/polityka-prywatnosci/"
    }
  }, [_vm._v("Polityka prywatności")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-162",
    attrs: {
      "id": "menu-item-162"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/kontakt/"
    }
  }, [_vm._v("Kontakt")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-custom menu-item-object-custom menu-item-163",
    attrs: {
      "id": "menu-item-163"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Zaloguj")])])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])])])])])])
}]}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageMenu'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app-main"
    }
  }, [_vm._m(0), _vm._v(" "), _c('finished-order-popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinishedOrderPopup),
      expression: "showFinishedOrderPopup"
    }],
    on: {
      "setFinishedOrderPopup": _vm.setFinishedOrderPopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('final-step', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "payuUrl": _vm.payuUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-new desktop-order-form"
  }, [_c('step-bar', {
    attrs: {
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('vendor-agata-location-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 1),
      expression: "orderStep == 1"
    }],
    attrs: {
      "warehouseError": _vm.warehouseError
    },
    on: {
      "setVendorWarehouse": _vm.setVendorWarehouse
    }
  }), _vm._v(" "), _c('delivery-type-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        false &&
        _vm.orderData.warehouse &&
        _vm.orderData.warehouse.ID == 9
      ),
      expression: "\n                        false &&\n                        orderData.warehouse &&\n                        orderData.warehouse.ID == 9\n                    "
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('delivery-address-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 2),
      expression: "orderStep == 2"
    }],
    attrs: {
      "zone": _vm.orderData.delivery.zone,
      "step": _vm.orderStep,
      "warehouse": _vm.orderData.warehouse,
      "address": _vm.orderData.address,
      "addressError": _vm.addressError
    },
    on: {
      "setCustomerLocation": _vm.setCustomerLocation,
      "setAddressError": _vm.setAddressError
    }
  }), _vm._v(" "), _c('address-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 2),
      expression: "orderStep == 2"
    }],
    attrs: {
      "step": _vm.orderStep,
      "address": _vm.orderData.address,
      "warehouse": _vm.orderData.warehouse
    },
    on: {
      "setDelivDistance": _vm.setDelivDistance
    }
  }), _vm._v(" "), _c('parcels-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 3),
      expression: "orderStep == 3"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderParts": _vm.orderData.parts
    },
    on: {
      "parcelsValid": _vm.parcelsValid,
      "addPart": _vm.addPart,
      "removePart": _vm.removePart
    }
  }), _vm._v(" "), _c('order-details', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 4),
      expression: "orderStep == 4"
    }],
    attrs: {
      "warehouse": _vm.orderData.warehouse,
      "orderParts": _vm.orderData.parts,
      "address": _vm.orderData.address
    },
    on: {
      "setDeliveryOptionsError": _vm.setDeliveryOptionsError,
      "setDeliveryCost": _vm.setDeliveryCost,
      "addPart": _vm.addPart,
      "setOrderStep": _vm.setOrderStep,
      "setDelivDate": _vm.setDelivDate,
      "setDelivDistance": _vm.setDelivDistance,
      "setCustomerLocation": _vm.setCustomerLocation,
      "setDelivTimePeriod": _vm.setDelivTimePeriod,
      "removePart": _vm.removePart
    }
  }), _vm._v(" "), _c('order-summary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 5 || _vm.orderStep == 6),
      expression: "orderStep == 5 || orderStep == 6"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    },
    on: {
      "setOrderStep": _vm.setOrderStep,
      "setCustomerDataError": _vm.setCustomerDataError
    }
  }), _vm._v(" "), _c('order-nav-section', {
    attrs: {
      "step": _vm.orderStep
    },
    on: {
      "setFinishedOrderPopup": _vm.setFinishedOrderPopup,
      "pay": _vm.pay,
      "createOrder": _vm.createOrder,
      "setOrderStep": _vm.setOrderStep
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('order-price-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep >= 3),
      expression: "orderStep >= 3"
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "step": _vm.orderStep
    },
    on: {
      "changeMannualyDelivCost": _vm.changeMannualyDelivCost
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "instruction-img",
    attrs: {
      "src": "/images/instr-img.png"
    }
  }), _vm._v(" "), _c('right-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep != 6),
      expression: "orderStep != 6"
    }],
    attrs: {
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('delivery-point-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    }
  }), _vm._v(" "), _c('first-step-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 1),
      expression: "orderStep == 1"
    }]
  }), _vm._v(" "), _c('summary-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep > 1),
      expression: "orderStep > 1"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    }
  }), _vm._v(" "), _c('parcels-summary-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep > 3),
      expression: "orderStep > 3"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderParts": _vm.orderData.parts
    }
  }), _vm._v(" "), _c('help-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep === 6),
      expression: "orderStep === 6"
    }],
    attrs: {
      "step": _vm.orderStep
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.payuUrl),
      expression: "!payuUrl"
    }],
    staticClass: "col-12"
  }, [_c('CallCenterMap', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "deliveryAddress": _vm.orderData.address,
      "warehouse": _vm.orderData.warehouse,
      "division": _vm.orderData.warehouse
    }
  })], 1)], 1), _vm._v(" "), _c('PageFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "section-header no-icon"
  }, [_c('h1', [_vm._v("Zamówienie usługi transportowej")])])])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 6),
      expression: "step === 6"
    }],
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-card"
  }), _vm._v(" "), _c('h2', [_vm._v("Płatność online (Zamówienie nr " + _vm._s(_vm.orderData.orderNumber) + ")")])]), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "desktop-order-summary"
  }, [_c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Nadawca")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.customer.FirstName) + "\n                    " + _vm._s(_vm.orderData.customer.LastName) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.address.Street) + "\n                    " + _vm._s(_vm.orderData.address.StreetNo) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.orderData.address.PostalCode) + "\n                    " + _vm._s(_vm.orderData.address.City) + "\n                ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Kwota do zapłaty")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)))])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ost-entry"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v("1.")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [(_vm.orderData.delivery.withCarry == 1) ? _c('em', [_vm._v("Dostawa z wniesieniem\n                    " + _vm._s(_vm.orderData.order.extOrderId))]) : _vm._e(), _vm._v(" "), (_vm.orderData.delivery.withCarry == 0) ? _c('em', [_vm._v("Dostawa " + _vm._s(_vm.orderData.order.extOrderId))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("\n                " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + " zł\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ost-summary"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v(" ")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [_vm._v("SUMA")]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("\n                " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + " zł\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), (_vm.step === 6 && _vm.orderType != '') ? _c('div', [_vm._v("\n        URL dla klienta:\n        "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkToPay),
      expression: "linkToPay"
    }],
    staticStyle: {
      "border": "1px solid #ddd",
      "font-size": "20px",
      "width": "600px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkToPay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkToPay = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 6 && _vm.orderType == '') ? _c('div', {
    staticClass: "ui one column grid container"
  }, [_c('div', {
    staticClass: "column",
    attrs: {
      "id": "payments-option-list"
    }
  }, _vm._l((_vm.methodsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "payu-method"
    }, [_c('img', {
      staticClass: "pay-method-logo",
      staticStyle: {
        "display": "block !important",
        "margin": "5px auto 12px auto"
      },
      attrs: {
        "src": item.brandImageUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.orderData.order.payMethod),
        expression: "orderData.order.payMethod"
      }],
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "type": "radio",
        "name": "payMethod"
      },
      domProps: {
        "value": item.value,
        "checked": _vm._q(_vm.orderData.order.payMethod, item.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.orderData.order, "payMethod", item.value)
        }
      }
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('payu-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "order": _vm.orderData.order
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 6),
      expression: "step === 6"
    }],
    staticClass: "order-info-block acceptance-block mb-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.acceptPayuRules),
      expression: "orderData.acceptPayuRules"
    }],
    attrs: {
      "type": "checkbox",
      "id": "payu-acceptance",
      "name": "payu-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderData.acceptPayuRules) ? _vm._i(_vm.orderData.acceptPayuRules, null) > -1 : (_vm.orderData.acceptPayuRules)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderData.acceptPayuRules,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderData, "acceptPayuRules", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderData, "acceptPayuRules", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderData, "acceptPayuRules", $$c)
        }
      }
    }
  }), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "payu-info"
  }, [_vm._v("\n            Zlecenie realizacji płatności: Zlecenie wykonuje PayU SA; Dane\n            odbiorcy, tytuł oraz kwota płatności dostarczane są PayU SA\n            przez odbiorcę; Zlecenie jest przekazywane do realizacji po\n            otrzymaniu przez PayU SA Państwa wpłaty. Płatność udostępniana\n            jest odbiorcy w ciągu 1 godziny, nie później niż do końca\n            następnego dnia roboczego; PayU SA nie pobiera opłaty od\n            realizacji usługi.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "payu-info payu-last"
  }, [_vm._v("\n            Administratorem Twoich danych osobowych w rozumieniu ustawy z\n            dnia 29 sierpnia 1997 r. o ochronie danych osobowych (tj. Dz.U.\n            z 2002 roku, nr 101, poz. 926 z późn. zm.) jest PayU SA z\n            siedzibą w Poznaniu (60-166), przy ul. Grunwaldzkiej 182. Twoje\n            dane osobowe będą przetwarzane zgodnie z obowiązującymi\n            przepisami prawa, w celu świadczenia usług i archiwizacji. Twoje\n            dane nie będą udostępniane innym podmiotom, z wyjątkiem\n            podmiotów upoważnionych na podstawie przepisów prawa.\n            Przysługuje Tobie prawo dostępu do treści swoich danych oraz ich\n            poprawiania. Podanie danych jest dobrowolne, ale niezbędne do\n            realizacji ww. celu.\n        ")])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "contactForm pb-20",
    attrs: {
      "target": "_top",
      "custom-validation-reporting": "show-all-on-submit"
    }
  }, [_c('fieldset', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.FirstName),
      expression: "orderData.customer.FirstName"
    }],
    staticClass: "contactField",
    class: {
      'error-field':
      _vm.customerFieldsError.FirstName == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Imię') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Imię')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "FirstName", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.LastName),
      expression: "orderData.customer.LastName"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.customerFieldsError.LastName == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Nazwisko') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Nazwisko')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "LastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.Email),
      expression: "orderData.customer.Email"
    }],
    staticClass: "contactField",
    class: {
      'error-field': _vm.customerFieldsError.Email == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'E-mail') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'E-mail')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "Email", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.customer.MobilePhone),
      expression: "orderData.customer.MobilePhone"
    }],
    staticClass: "contactField",
    class: {
      'error-field':
      _vm.customerFieldsError.MobilePhone == true,
    },
    attrs: {
      "type": "text",
      "name": "Name",
      "onfocus": "(this.value == 'Nr telefonu komórkowego') && (this.value = '')",
      "onblur": "(this.value == '') && (this.value = 'Nr telefonu komórkowego')",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.customer.MobilePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.customer, "MobilePhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block acceptance-block no-email-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noEmail),
      expression: "noEmail"
    }],
    staticClass: "noEmail",
    attrs: {
      "type": "checkbox",
      "name": "noEmail",
      "id": "noEmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.noEmail) ? _vm._i(_vm.noEmail, null) > -1 : (_vm.noEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.noEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.noEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.noEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.noEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "noEmail",
    attrs: {
      "for": "noEmail"
    }
  }, [_vm._v("Nie posiadam adresu e-mail i rezygnuję z powiadomień\n                    dotyczących realizacji zlecenia")])])]), _vm._v(" "), _c('fieldset', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.remarks),
      expression: "orderData.remarks"
    }],
    staticClass: "order-form-comments",
    attrs: {
      "rows": "10",
      "cols": "30"
    },
    domProps: {
      "value": (_vm.orderData.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData, "remarks", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerDataError),
      expression: "customerDataError"
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wypełnienie wszystkich pól.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.customerDataError &&
        _vm.orderData.customer.MobilePhone != ''
      ),
      expression: "\n                    customerDataError &&\n                    orderData.customer.MobilePhone != ''\n                "
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wpisanie właściwego numeru telefonu w formacie 9\n                cyfr nie rozdzielonych spacjami.\n            ")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('a', {
    staticClass: "float-left button bg-blue full-bottom order-change-data-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showInfBox()
      }
    }
  }, [_vm._v("Zmień dane do faktury")]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInvoicePart),
      expression: "showInvoicePart"
    }]
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.CompanyName),
      expression: "orderData.invoice.CompanyName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Nazwa firmy lub podmiotu",
      "id": "Company",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "CompanyName", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.NIP),
      expression: "orderData.invoice.NIP"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "NIP",
      "id": "NIP",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.NIP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "NIP", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.FirstName),
      expression: "orderData.invoice.FirstName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Imię",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.LastName),
      expression: "orderData.invoice.LastName"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Nazwisko",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "LastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.Street),
      expression: "orderData.invoice.Street"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Name",
      "placeholder": "Ulica",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.Street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "Street", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.StreetNo),
      expression: "orderData.invoice.StreetNo"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Nr-budynku",
      "placeholder": "Nr budynku",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.StreetNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "StreetNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.ApartmentNo),
      expression: "orderData.invoice.ApartmentNo"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Nr-lokalu",
      "placeholder": "Nr lokalu",
      "id": "Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.ApartmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "ApartmentNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.City),
      expression: "orderData.invoice.City"
    }],
    staticClass: "contactField",
    attrs: {
      "type": "text",
      "name": "Miejscowosc",
      "placeholder": "Miejscowość",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "City", $event.target.value)
      }
    }
  }), _c('span', {
    attrs: {
      "visible-when-invalid": "valueMissing",
      "validation-for": "name5"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderData.invoice.PostalCode),
      expression: "orderData.invoice.PostalCode"
    }],
    staticClass: "contactField order-field-name",
    attrs: {
      "type": "text",
      "name": "Kod-pocztowy",
      "maxlength": "6",
      "placeholder": "Kod pocztowy",
      "id": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.orderData.invoice.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderData.invoice, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerDataError && _vm.showInvoicePart),
      expression: "customerDataError && showInvoicePart"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n                Prosimy o wypełnienie wszystkich niezbędnych pól.\n            ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Odbiorca")]), _vm._v(" "), _c('p', [_vm._v("DTS Transport Sp. z o.o.")]), _vm._v(" "), _c('p', [_vm._v("ul. Wał Miedzeszyński 251,")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Forma płatności")]), _vm._v(" "), _c('p', [_vm._v("Przelew online")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ost-header"
  }, [_c('p', {
    staticClass: "ost-number"
  }, [_vm._v("Lp.")]), _vm._v(" "), _c('p', {
    staticClass: "ost-name"
  }, [_vm._v("Nazwa usługi")]), _vm._v(" "), _c('p', {
    staticClass: "ost-price"
  }, [_vm._v("Kwota")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "payu-check"
    }
  }, [_vm._v("Akceptuję\n            "), _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "http://static.payu.com/sites/terms/files/payu_terms_of_service_single_transaction_pl_pl.pdf"
    }
  }, [_vm._v("\"Regulamin pojedynczej transakcji płatniczej PayU\"")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-person"
  }), _vm._v(" "), _c('h2', [_vm._v("Dane odbiorcy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Podając dane osobowe potwierdzam prawidłowość adresu\n                    dostawy, kwot zamówień z Salonu Agata Meble, a także\n                    pozostałych danych wprowadzonych w procesie rejestracji\n                    zamówienia dostawy. Deklaruję tym samym chęć\n                    skorzystania z oferty usługi transportowej zawartej w\n                    formularzu.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane osobowe wykorzystywane są jedynie w\n                    procesie rejestracji zamówienia, jego realizacji,\n                    kontroli jakości, a także notyfikowania użytkownika\n                    drogą mailową i smsową o jego przebiegu.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane nie są udostępniane osobom trzecim, ani\n                    podmiotom zewnętrznym.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-alert"
  }), _vm._v(" "), _c('h2', [_vm._v("Uwagi do zamówienia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Jeśli masz uwagi, które chciałbyś przekazać zespołowi\n                    realizacyjnemu, wpisz je w poniższym polu.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                Jeżeli chcesz otrzymać fakturę VAT, prosimy o skorzystanie z\n                poniżej opcji, a następnie wypełnienie niezbędnych pól.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-document-text"
  }), _vm._v(" "), _c('h2', [_vm._v("Faktura VAT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Wprowadzone dane wykorzystywane są jedynie w celach\n                    wystawienia Faktury VAT i nie są udostępniane osobom\n                    trzecim, ani podmiotom zewnętrznym.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("\n                    Domyślnie załadowane zostają dane wprowadzone dotychczas\n                    w procesie rejestracji zamówienia dostawy. Prosimy o ich\n                    sprawdzenie i ewentualną zmianę.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_c('b', [_vm._v("UWAGA:")]), _vm._v(" zmiana danych do faktury nie skutkuje\n                    zmianą wprowadzonych danych osobowych i adresu\n                    realizacji.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "field-title orderStartPoint order-header-label",
    attrs: {
      "for": "orderStartPoint"
    }
  }, [_c('i', {})])
}]}

/***/ })
]),[203]);


// WEBPACK FOOTER //
// static/js/app.7a82e586e9db00a5bda4.js